(function(){
  "use strict";

  /* ---------- GUARD: evita doble carga si el bloque se pega 2 veces ---------- */
  if(window.__overdmaBundleLoaded){ return; }
  window.__overdmaBundleLoaded = true;

  /* ---------- IMAGENES (URLs publicas de tu Shopify) ---------- */
  var IMG_LOGO   = "https://cdn.shopify.com/s/files/1/0621/1380/8478/files/png1_1.png?v=1760318715&width=240";
  var IMG_MASCOT = "https://cdn.shopify.com/s/files/1/0621/1380/8478/files/Photoroom_20260622_150625.png?v=1782802504&width=240";
  var IMG_DISCORD= "https://cdn.shopify.com/s/files/1/0621/1380/8478/files/discord.png?v=1782883523&width=64";
  var IMG_RESET  = "https://cdn.shopify.com/s/files/1/0621/1380/8478/files/circular.png?v=1782884166&width=64";
  var IMG_CARD   = "https://cdn.shopify.com/s/files/1/0621/1380/8478/files/credit-card.png?v=1782884522&width=64";

  /* ---------- VARIANT IDS REALES (Shopify) ---------- */
  var V = {
    card75:    42173883777118,
    card100:   42173883809886,
    cardM2:    42627163881566,   // DMA Card M2 - Thunderbolt 4 / USB4 (laptops)
    fuser10:   43082578559070,   // GODLIKE 10th Gen HDMI (reemplazo del 6th Gen, descontinuado)
    fuserGL:   43034578124894,   // GODLIKE 4K Pro Fuser (reemplazo del D60, descontinuado)
    fuserDC:   43038536335454,   // DC500 4K Fuser (alto refresco) - PREVENTA
    fuserDC5:  43268436885598,   // 4K DC505 Fuser (flagship, solo en el DREAM) - PREVENTA
    makcu:     41984344424542,
    ferrum:    43062018539614,   // Ferrum One (apuntado tope de gama)
    xim:       42423776247902,
    fwEAC:     42068181647454,   // Firmware 1:1 Emulated EAC/ACE/BE/COD
    fwBE:      41995159502942,   // Firmware 1:1 Emulated BE/COD/BF/FiveM (variante unica)
    fwPriv:    42960613834846,   // Firmware 1:1 PRIVATE EAC (tier exclusivo - Dream Bundle)
    fwPro:     43225573851230,   // Firmware PRO BE/COD/BF/FiveM (6 meses de garantia; NO soporta M2)
    install:   41985014661214
  };

  /* ---------- TARJETA + FIRMWARE EN UNA VARIANTE (producto dma-pcie-card) ----------
     Comprar la tarjeta con el firmware incluido sale mas barato que por separado.
     Se usa en configs a la carta de PC de escritorio. */
  var CARD_FW = {
    '75': { be:{vid:42960628940894, p:179.99}, eac:{vid:42960628973662, p:269.99} },
    '100':{ be:{vid:42960629006430, p:199.99}, eac:{vid:42960629039198, p:289.99} }
  };

  /* ---------- STARTER BUNDLE (Card + GODLIKE 10th Gen HDMI + MAKCU + FW, en 1 SKU) ----------
     Se usa cuando la config es HDMI + Aimbot: sale mas barato que las piezas sueltas.
     >>> MANTENER SINCRONIZADO CON SHOPIFY (producto: OverDMA Starter Bundle) <<< */
  var BUNDLE = {
    '75': { none:{vid:42605644906590, p:259.99}, be:{vid:42960471588958, p:329.99}, eac:{vid:42960471621726, p:399.99} },
    '100':{ none:{vid:42960471654494, p:289.99}, be:{vid:42960471687262, p:359.99}, eac:{vid:42960471720030, p:429.99} }
  };

  /* ---------- 4K BUNDLE (Card + GODLIKE 4K Pro Fuser + MAKCU + Firmware) ----------
     Se usa cuando la config es monitor 4K/240Hz + Aimbot: ahorra vs. piezas sueltas.
     Producto: "OverDMA 4K DMA Bundle" (handle dma-bundle-4k). */
  var BUNDLE4K = {
    '75': { none:{vid:42611974144094, p:534.99}, be:{vid:42996605616222, p:609.99}, eac:{vid:42996605648990, p:679.99} },
    '100':{ none:{vid:42611974176862, p:564.99}, be:{vid:42996605681758, p:639.99}, eac:{vid:42996605714526, p:709.99} }
  };

  /* ---------- 4K PRO BUNDLE (Card + DC500 Fuser + MAKCU + Firmware) ----------
     Config de monitor 360Hz+/4K 160Hz + Aimbot. Producto: "OverDMA 4K Pro DMA
     Bundle" (handle dma-bundle-4k-pro-dc500). */
  var BUNDLE4KPRO = {
    '75': { none:{vid:43056340926558, p:649.99}, be:{vid:43056341352542, p:724.99}, eac:{vid:43056341385310, p:794.99} },
    '100':{ none:{vid:43056341418078, p:679.99}, be:{vid:43056341450846, p:754.99}, eac:{vid:43056341483614, p:824.99} }
  };

  /* MONITOR -> FUSER. El cliente elige SU resolucion y SUS Hz; el quiz pone el fuser
     MAS BARATO que en su ficha soporte ese monitor. Fichas (septiembre 2026):
       GODLIKE 10th Gen HDMI : 1080p hasta 240 · 1440p 144 · 3440x1440 100 · 4K 60
       GODLIKE 4K Pro (DP)   : 1080p hasta 360 · 1440p 240 · 3440x1440 SOLO 60 · 4K 120
       DC500 (HDMI2.1/DP1.4) : 1080p 480-540 · 1440p 320-355 · 4K 158-160 · ultrawide
       DC505 (HDMI2.1/DP1.4) : 1080p 550 · 1440p 360 · 4K 160 · ultrawide
     Ojo ultrawide: el 4K Pro solo da 60Hz ahi, peor que el 10th Gen (100Hz).
     Cada rango: [clave, etiqueta (clave de texto o literal), fuser]. */
  var MON = {
    '1080':{lbl:'1080p', sub:'Full HD · 1920×1080',
            hz:[['a','hzTo240','hdmi'],['b','280–360Hz','gl4k'],['c','hz480','dc500']]},
    '1440':{lbl:'1440p', sub:'2K · 2560×1440',
            hz:[['a','hzTo144','hdmi'],['b','165–240Hz','gl4k'],['c','270–320Hz','dc500'],['d','hz360','dc505']]},
    'uw':  {lbl:'Ultrawide', sub:'3440×1440',
            hz:[['a','hzTo100','hdmi'],['b','hz120','dc500']]},
    '4k':  {lbl:'4K', sub:'UHD · 3840×2160',
            hz:[['a','60Hz','hdmi'],['b','120Hz','gl4k'],['c','hz144','dc500']]}
  };
  var MON_ORDER = ['1080','1440','uw','4k'];

  var GL_NAME  = 'GODLIKE 4K Pro Fuser';
  var F10_NAME = 'GODLIKE 10th Gen HDMI Fuser';
  var DC_NAME  = 'DC500 4K Fuser';
  var DC5_NAME = '4K DC505 Fuser';
  var FW_PRO_NAME  = 'Firmware PRO · BE / COD / BF / FiveM';
  var FW_PRIV_NAME = 'Firmware 1:1 PRIVATE · EAC / ACE / BE / COD';

  /* ---------- NOMBRES DE FIRMWARE (como se muestran; matchean la tienda) ---------- */
  var FW_NAME = {
    eac:'Firmware 1:1 Emulated · EAC / ACE / BE / COD',
    be: 'Firmware 1:1 Emulated · BE / COD / BF / FiveM'
  };

  /* ---------- SYNC EN VIVO: precios y stock desde la propia tienda ----------
     Usa el endpoint publico /products/{handle}.js de Shopify. Si falla (p.ej.
     en preview local), quedan los precios hardcodeados de arriba como respaldo. */
  var HANDLES = ['dma-pcie-card','dma-card-m2','godlike-10th-gen-hdmi-fuser','godlike-4k-pro-fuser',
                 'dc500-4k-high-refresh-fuser','makcu','ferrum','xim-matrix',
                 '1-1-emulated-ace-eac-be-cod','1-1-emulated-fw-fivem-battleye-ricochet-valve-ac',
                 'instalacion-profesional-dma-configuracion-firmware','overdma-bundle','dma-bundle-4k',
                 'dma-bundle-4k-pro-dc500','overdma-4k-dc505-fuser',
                 'emulated-be-cod-bf-fivem-pro-firmware-tier'];
  /* DISPONIBILIDAD: el quiz NO muestra stock (decision de Over: todo se ofrece),
     pero si Shopify dice que una variante NO se puede vender, /cart/add la rechaza
     y el cliente se queda sin comprar al final del quiz (caso real 2026-09: el
     4K Pro Bundle y la DMA M2 quedaron en 'no disponible' y el carrito fallaba).
     Por eso se lee 'available': desconocido = disponible; solo false cuenta. */
  var AVAIL = {};
  function avail(vid){ return AVAIL[vid] !== false; }
  var liveSynced = false, syncRenderT = null;
  function scheduleSyncRender(){
    if(syncRenderT) return;
    syncRenderT = setTimeout(function(){
      syncRenderT = null;
      if(root && S.step>6 && S.phase==='result' && !S.adding) render();
    }, 150);
  }
  function syncLive(){
    if(liveSynced) return;
    liveSynced = true;
    HANDLES.forEach(function(h){
      fetch('/products/'+h+'.js').then(function(r){ return r.ok ? r.json() : null; }).then(function(prod){
        if(!prod || !prod.variants) return;
        prod.variants.forEach(function(v){
          AVAIL[v.id] = (v.available !== false);
          var price = v.price/100;
          for(var k in V){ if(V[k]===v.id) P[k]=price; }
          [BUNDLE, BUNDLE4K, BUNDLE4KPRO, CARD_FW].forEach(function(B){
            for(var tier in B){ for(var ty in B[tier]){ if(B[tier][ty].vid===v.id) B[tier][ty].p=price; } }
          });
        });
        // refrescar solo la pantalla de resultado (evita interrumpir quiz/form/analisis);
        // las 16 respuestas se agrupan en un solo re-render y nunca durante la compra.
        scheduleSyncRender();
      }).catch(function(){});
    });
  }

  /* ========================================================================
     PRECIOS  ·  >>> MANTENER SINCRONIZADO CON SHOPIFY <<<
     Si cambias un precio en Shopify, actualizalo aqui tambien o el total
     mostrado quedara desfasado (el cobro real lo hace Shopify de todos modos).
     ======================================================================== */
  var P = {
    card75:129.99, card100:149.99, cardM2:149.99,
    fuser10:145.00, fuserGL:399.00, fuserDC:499.99, fuserDC5:599.00,
    makcu:30.00, ferrum:160.00, xim:169.99,
    fwEAC:159.99, fwBE:79.99, fwPro:100.00, fwPriv:499.99, install:50.00
  };

  /* ---------- GRUPOS DE JUEGOS ---------- */
  /* Regla de firmware (confirmada): el firmware EAC cubre TODOS los juegos;
     el V2.4 cubre BattlEye/Ricochet/Javelin + "Otros", pero NO cubre EAC.
     => Si hay cualquier juego EAC u "Otros" -> se recomienda SOLO el EAC.
        Si no hay ninguno de esos -> se recomienda SOLO el V2.4. Nunca dos. */
  var EAC      = ['Fortnite','Rust','Apex Legends','ARC Raiders'];
  var OTROS    = ['Arena Breakout Infinite','Delta Force','Counter-Strike 2','GTA / FiveM'];
  var BE       = ['Escape from Tarkov','Rainbow Six Siege','DayZ','PUBG','Arma'];
  var RICOCHET = ['Call of Duty Series (Warzone)'];
  var JAVELIN  = ['Battlefield Series'];

  var GAMES = [
    {key:'gEac', items:EAC},
    {key:'gBe', items:BE},
    {key:'gRico', items:RICOCHET},
    {key:'gJav', items:JAVELIN},
    {key:'gOtros', items:OTROS}
  ];

  /* ---------- TEXTOS ES / EN ---------- */
  var T = {
    es:{pickPc:'Elige si juegas en escritorio o laptop.', pickFeat:'Elige una opción.', pickRes:'Elige la resolución de tu monitor.', pickHz:'Ahora elige los Hz de tu monitor.', pickPer:'Elige tu periférico.', pickBud:'Elige tu presupuesto.', yourPick:'Tu elección', cartErr:'No pudimos añadirlo al carrito. Inténtalo de nuevo o escríbenos en Discord.', cartSlow:'La conexión va lenta. Si no avanza en unos segundos, abre tu carrito:', viewCart:'Ver carrito', copyFail:'No se pudo copiar', dialogLbl:'Asistente de bundles OverDMA',
      step:'Paso', of:'de', result:'Resultado', back:'Atrás', next:'Siguiente', skip:'Saltar', seeBundle:'Ver mi bundle',
      q1:'¿Qué juegos vas a jugar?', q1s:'Selecciona todos los que apliquen. Esto define tu firmware.',
      qPc:'¿Juegas en PC de escritorio o laptop?', qPcS:'Esto define qué tarjeta DMA lleva tu setup.',
      deskOpt:'PC de escritorio', deskOptS:'Tarjeta DMA PCIe · 75T / 100T',
      lapOpt:'Laptop', lapOptS:'DMA Card M2 · Thunderbolt 4 / USB4',
      m2Note:'Importante: tu laptop debe tener un puerto Thunderbolt 4 / USB4. La DMA Card M2 NO funciona en puertos USB 3.0 / 3.2.',
      gEac:'EAC — Easy Anti-Cheat', gBe:'BattlEye', gRico:'Ricochet', gJav:'Javelin', gOtros:'Otros Anti-Cheats',
      q2:'¿Qué características quieres?', q2s:'Elige una opción. El aimbot habilita el MAKCU; el ESP habilita el fuser.',
      aimOnly:'Solo Aimbot', aimOnlyS:'Apuntado asistido · necesita MAKCU',
      espOnly:'Solo ESP', espOnlyS:'Wallhack / radar · necesita fuser',
      both:'Aimbot + ESP', bothS:'Ambas funciones · MAKCU + fuser',
      q3:'¿Qué monitor tienes?', q3s:'El fuser muestra el ESP en tu monitor. Sin ESP no lo necesitas.',
      resLbl:'Resolución', hzLbl:'Frecuencia (Hz)', hzUnknown:'No sé mis Hz',
      hzTo240:'Hasta 240Hz', hzTo144:'Hasta 144Hz', hzTo100:'Hasta 100Hz',
      hz480:'480Hz o más', hz360:'360Hz o más', hz120:'120Hz o más', hz144:'144Hz o más',
      hzHelp:'¿No sabes tus Hz? En Windows: Configuración → Sistema → Pantalla → Pantalla avanzada. Ahí aparece la frecuencia de actualización.',
      noHzNote:'No sabías los Hz de tu monitor, así que te pusimos el fuser de entrada (GODLIKE 10th Gen: hasta 1080p 240Hz · 1440p 144Hz · ultrawide 100Hz · 4K 60Hz). Si tu monitor va a más Hz, revísalo antes de comprar en Windows → Configuración → Sistema → Pantalla → Pantalla avanzada, o escríbenos.',
      recGrp:'Recomendados para ti', dreamGrp:'¿Quieres lo máximo?', orSep:'o',
      noEsp:'No elegiste ESP, así que no necesitas fuser. Dale a Saltar.',
      q4:'¿Qué periférico usas?', q4s:'El MAKCU ejecuta el aimbot. Sin aimbot no lo necesitas.',
      noAim:'No elegiste aimbot, así que no necesitas MAKCU ni XIM. Dale a Saltar.',
      km:'Mouse y teclado', kmS:'Necesita el MAKCU', ctrl:'Control', ctrlS:'Necesita MAKCU + XIM MATRIX',
      q5:'¿Cuál es tu presupuesto?', q5s:'Marcaremos cuál bundle entra en tu rango y cuál es el ideal.',
      resTitle:'Tu bundle recomendado', fwLabel:'Firmware ideal',
      mascotMsg1:'Según los juegos que elegiste', mascotMsg2:'Over te armó este setup a tu medida.', more:'más',
      pickGame:'Selecciona al menos un juego.', budgetCard:'Opción según tu presupuesto', idealCard:'Opción ideal según tus elecciones',
      economic:'Económico · 75T', recommended:'Recomendado · 100T', total:'Total', addCart:'Añadir al carrito', adding:'Añadiendo…',
      dreamCard:'Lo mejor de lo mejor', dreamTag:'Top de gama', dreamRib:'DREAM BUNDLE',
      whyTitle:'Por qué es lo mejor',
      wDC5:'DC505, el fuser flagship: hasta 1080p 550Hz · 1440p 360Hz · 4K 160Hz, con capturadora integrada',
      w100:'DMA 100T: la tarjeta de alto rendimiento',
      wPriv:'Firmware Privado: perfil de hardware exclusivo, de muy baja distribución',
      wFer:'Ferrum One: 8000Hz de polling y passthrough perfecto',
      laptopCard:'Tu setup para laptop', laptopTag:'DMA M2 · Laptop',
      fitOk:'✓ Dentro de tu presupuesto', fitOver:'Por encima de tu rango',
      saveL:'Ahorras', saveR:'vs. comprar suelto',
      incTitle:'Incluye', incCables:'Todos los cables (USB-C · USB · HDMI)', incSupport:'Soporte 1:1 por ticket incluido',
      incCablesDP:'Cables incluidos (2x DisplayPort · 2x USB · USB-C)', incRemote:'Control remoto incluido',
      incCablesDC:'Cables incluidos (3x DisplayPort · 2x USB · USB-C)',
      dpNote:'El GODLIKE 4K Pro se conecta 100% por DisplayPort (no usa HDMI). Verifica que tus 2 PCs y tu monitor tengan puertos DisplayPort libres.',
      dcNote:'Preventa: el DC500 viene en camino y se envía en cuanto llega, en orden de compra. Usa HDMI 2.1 + DisplayPort 1.4: en modo DP ambas PCs necesitan Nvidia serie 10 / AMD RX 500 o superior; en HDMI 2.1, GPU RTX 3060 / RX 6500XT o mejor y monitor HDMI 2.1 de banda completa. La PC secundaria necesita un CPU de 6+ hilos. Llega hasta 1080p 540Hz · 1440p 355Hz · 4K 160Hz.',
      dc5Note:'Preventa: el DC505 se envía en cuanto llega el stock, en orden de compra, con tracking. Importante: no se pueden mezclar conectores — tu PC gaming, la PC DMA y el monitor deben ir todos por HDMI 2.1 o todos por DisplayPort. Ambas PCs necesitan GPU dedicada (Nvidia serie 10 / AMD RX 500 o superior) y la PC DMA un CPU de 6+ hilos. Llega hasta 1080p 550Hz · 1440p 360Hz · 4K 160Hz.',
      oosNote:'Un producto de este setup está agotado en este momento. Escríbenos en Discord y te lo reservamos para cuando llegue.',
      soldTag:'Agotado', reserveCta:'Reservar por Discord', noFw:'sin FW',
      proTitle:'Firmware PRO', proDesc:'Nuestro firmware más avanzado: garantía de 6 meses, número de serie único y vinculado a tu DNA ID.',
      installTitle:'DMA Installation Service', optional:'opcional', popBadge:'⭐ Recomendado',
      installDesc:'Setup remoto completo vía AnyDesk + Discord. Todo pedido ya incluye soporte 1:1 por ticket.',
      copyBuild:'Copiar mi build', copied:'¡Copiado! Pégalo en tu ticket',
      noGame:'¿No ves tu juego? Pregúntanos en Discord',
      financing:'Financiamiento disponible: Affirm · PayPal Pay Later · Shop Pay Installments.',
      redo:'Rehacer quiz', talk:'Hablar con nosotros', addOns:'Añade a tu orden', orderTotal:'Total de la orden',
      bubbleTitle:'¿Armamos tu setup?', bubbleMsg:'Soy Over. Te ayudo a elegir el bundle perfecto en 1 minuto. Sin complicaciones.',
      bubbleCta:'Empezar', launcherAria:'Abrir el asistente de bundles OverDMA', closeAria:'Cerrar',
      anTitle:'Analizando tu configuración', anSteps:['Leyendo tus juegos…','Detectando anti-cheats…','Calculando el firmware ideal…','Armando tu bundle…','Casi listo…']},
    en:{pickPc:'Pick desktop or laptop.', pickFeat:'Pick one option.', pickRes:'Pick your monitor resolution.', pickHz:'Now pick your monitor Hz.', pickPer:'Pick your peripheral.', pickBud:'Pick your budget.', yourPick:'Your pick', cartErr:"We couldn't add it to your cart. Try again or message us on Discord.", cartSlow:'Slow connection. If nothing happens in a few seconds, open your cart:', viewCart:'View cart', copyFail:"Couldn't copy", dialogLbl:'OverDMA bundle assistant',
      step:'Step', of:'of', result:'Result', back:'Back', next:'Next', skip:'Skip', seeBundle:'See my bundle',
      q1:'Which games do you play?', q1s:'Select all that apply. This defines your firmware.',
      qPc:'Do you game on a desktop PC or a laptop?', qPcS:'This defines which DMA card your setup gets.',
      deskOpt:'Desktop PC', deskOptS:'DMA PCIe Card · 75T / 100T',
      lapOpt:'Laptop', lapOptS:'DMA Card M2 · Thunderbolt 4 / USB4',
      m2Note:'Important: your laptop must have a Thunderbolt 4 / USB4 port. The DMA Card M2 does NOT work on USB 3.0 / 3.2 ports.',
      gEac:'EAC — Easy Anti-Cheat', gBe:'BattlEye', gRico:'Ricochet', gJav:'Javelin', gOtros:'Other Anti-Cheats',
      q2:'Which features do you want?', q2s:'Pick one. Aimbot enables the MAKCU; ESP enables the fuser.',
      aimOnly:'Aimbot only', aimOnlyS:'Assisted aim · needs MAKCU',
      espOnly:'ESP only', espOnlyS:'Wallhack / radar · needs fuser',
      both:'Aimbot + ESP', bothS:'Both features · MAKCU + fuser',
      q3:'Which monitor do you have?', q3s:'The fuser shows ESP on your monitor. No ESP, no fuser needed.',
      resLbl:'Resolution', hzLbl:'Refresh rate (Hz)', hzUnknown:"I don't know my Hz",
      hzTo240:'Up to 240Hz', hzTo144:'Up to 144Hz', hzTo100:'Up to 100Hz',
      hz480:'480Hz or more', hz360:'360Hz or more', hz120:'120Hz or more', hz144:'144Hz or more',
      hzHelp:"Don't know your Hz? On Windows: Settings → System → Display → Advanced display. It shows your refresh rate.",
      noHzNote:"You didn't know your monitor's Hz, so we gave you the entry fuser (GODLIKE 10th Gen: up to 1080p 240Hz · 1440p 144Hz · ultrawide 100Hz · 4K 60Hz). If your monitor runs higher, check it before buying in Windows → Settings → System → Display → Advanced display, or message us.",
      recGrp:'Recommended for you', dreamGrp:'Want the very best?', orSep:'or',
      noEsp:'You did not pick ESP, so you do not need a fuser. Hit Skip.',
      q4:'What peripheral do you use?', q4s:'The MAKCU runs the aimbot. No aimbot, no MAKCU needed.',
      noAim:'You did not pick aimbot, so you do not need MAKCU or XIM. Hit Skip.',
      km:'Mouse and keyboard', kmS:'Needs the MAKCU', ctrl:'Controller', ctrlS:'Needs MAKCU + XIM MATRIX',
      q5:'What is your budget?', q5s:'We will mark which bundle fits your range and which is ideal.',
      resTitle:'Your recommended bundle', fwLabel:'Ideal firmware',
      mascotMsg1:'Based on the games you picked', mascotMsg2:'Over built this setup just for you.', more:'more',
      pickGame:'Select at least one game.', budgetCard:'Option for your budget', idealCard:'Ideal option for your picks',
      economic:'Budget · 75T', recommended:'Recommended · 100T', total:'Total', addCart:'Add to cart', adding:'Adding…',
      dreamCard:'The best of the best', dreamTag:'Top tier', dreamRib:'DREAM BUNDLE',
      whyTitle:'Why it is the best',
      wDC5:'DC505, the flagship fuser: up to 1080p 550Hz · 1440p 360Hz · 4K 160Hz, with a built-in capture card',
      w100:'DMA 100T: the high-performance card',
      wPriv:'Private Firmware: an exclusive hardware profile with very low distribution',
      wFer:'Ferrum One: 8000Hz polling and perfect passthrough',
      laptopCard:'Your laptop setup', laptopTag:'DMA M2 · Laptop',
      fitOk:'✓ Within your budget', fitOver:'Above your range',
      saveL:'You save', saveR:'vs. buying separately',
      incTitle:'Includes', incCables:'All cables (USB-C · USB · HDMI)', incSupport:'1:1 ticket support included',
      incCablesDP:'Cables included (2x DisplayPort · 2x USB · USB-C)', incRemote:'Remote control included',
      incCablesDC:'Cables included (3x DisplayPort · 2x USB · USB-C)',
      dpNote:'The GODLIKE 4K Pro connects 100% via DisplayPort (no HDMI). Make sure both PCs and your monitor have free DisplayPort ports.',
      dcNote:'Pre-order: the DC500 is on its way and ships as soon as it arrives, in order of purchase. It uses HDMI 2.1 + DisplayPort 1.4: in DP mode both PCs need Nvidia 10 series / AMD RX 500 or newer; in HDMI 2.1 mode, an RTX 3060 / RX 6500XT+ GPU and a full-bandwidth HDMI 2.1 monitor. The second PC needs a 6+ thread CPU. It reaches up to 1080p 540Hz · 1440p 355Hz · 4K 160Hz.',
      dc5Note:'Pre-order: the DC505 ships as soon as stock arrives, in order of purchase, with tracking. Important: connectors cannot be mixed — your gaming PC, DMA PC and monitor must all use HDMI 2.1 or all use DisplayPort. Both PCs need a dedicated GPU (Nvidia 10 series / AMD RX 500 or newer) and the DMA PC a 6+ thread CPU. It reaches up to 1080p 550Hz · 1440p 360Hz · 4K 160Hz.',
      oosNote:'An item in this setup is sold out right now. Message us on Discord and we will reserve it for you when it arrives.',
      soldTag:'Sold out', reserveCta:'Reserve on Discord', noFw:'no FW',
      proTitle:'PRO Firmware', proDesc:'Our most advanced firmware: 6-month warranty, unique serial number and locked to your DNA ID.',
      installTitle:'DMA Installation Service', optional:'optional', popBadge:'⭐ Recommended',
      installDesc:'Full remote setup via AnyDesk + Discord. Every order already includes 1:1 ticket support.',
      copyBuild:'Copy my build', copied:'Copied! Paste it in your ticket',
      noGame:"Don't see your game? Ask us on Discord",
      financing:'Financing available: Affirm · PayPal Pay Later · Shop Pay Installments.',
      redo:'Redo quiz', talk:'Talk to us', addOns:'Add to your order', orderTotal:'Order total',
      bubbleTitle:'Build your setup?', bubbleMsg:'I am Over. I will help you pick the perfect bundle in 1 minute. No hassle.',
      bubbleCta:'Start', launcherAria:'Open the OverDMA bundle assistant', closeAria:'Close',
      anTitle:'Analyzing your setup', anSteps:['Reading your games…','Detecting anti-cheats…','Calculating the ideal firmware…','Building your bundle…','Almost there…']}
  };

  /* ---------- ESTADO ---------- */
  var S = {step:1, lang:'es', games:{}, pcType:null, aimbot:false, esp:false, monitor:null, monitorFuser:null,
           monRes:null, monHz:null,
           periph:null, budget:null, addInstall:false, fwPro:false,
           chosen:'ideal', chosenManual:false, phase:null, adding:false, cartError:null, cartSlow:false};
  function t(k){ return T[S.lang][k]; }
  function gamesCount(){ return Object.keys(S.games).length; }
  function money(n){ return '$'+n.toFixed(2); }

  /* ---------- CSS (inyectado una sola vez) ---------- */
  var CSS = ''
   + '#overdma-quiz-root,.ovw-modal{--g:#F5A623;--gd:#C8821A;--dark:#0E0E10;--card:#1A1A1D;--line:#2A2A2E;--ok:#5FD27E;'
   + '--glass:rgba(255,255,255,.05);--glassBrd:rgba(255,255,255,.13);--glassHi:inset 0 1px 0 rgba(255,255,255,.10);}'
   + '.ovq-shell{font-family:Inter,system-ui,-apple-system,Segoe UI,Roboto,Arial,sans-serif;color:#EDEDED;}'
   + '.ovq-shell *{box-sizing:border-box;}'
   /* tactil: sin flash gris al tocar, sin zoom por doble toque, sin agrandar texto al rotar */
   + '.ovq-shell,#overdma-widget{-webkit-tap-highlight-color:transparent;-webkit-text-size-adjust:100%;text-size-adjust:100%;}'
   + '.ovq-shell button,.ovq-pcard,.ovq-addon,.ovw-bub,.ovw-tip,.ovw-close,.ovw-tip-x{touch-action:manipulation;}'
   + '.ovq-shell button,.ovq-pcard,.ovq-addon{-webkit-user-select:none;user-select:none;}'
   + '.ovq-h3:focus{outline:none;}'
   + '.ovq-pcard:focus,.ovq-addon:focus{outline:none;}'
   + '.ovq-pcard:focus-visible,.ovq-addon:focus-visible{outline:2px solid #FFD98A;outline-offset:3px;}'
   + '.ovq-shell{background:radial-gradient(1100px 480px at 88% -12%,rgba(245,166,35,.16),transparent 60%),'
   +   'radial-gradient(900px 520px at -12% 112%,rgba(139,146,245,.10),transparent 60%),'
   +   'linear-gradient(180deg,#111116,#0A0A0D);'
   +   'border-radius:20px;overflow:clip;border:1px solid rgba(255,255,255,.10);'
   +   'box-shadow:0 24px 70px rgba(0,0,0,.55);}'
   + '.ovq-head{padding:18px 22px;border-bottom:1px solid var(--line);display:flex;align-items:center;justify-content:space-between;gap:12px;flex-wrap:wrap;}'
   + '.ovw-modal-inner .ovq-head{padding-right:60px;}'
   + '.ovq-brand{display:flex;align-items:center;gap:12px;flex:1;min-width:0;}'
   + '.ovq-logo{height:42px;width:auto;display:block;}'
   + '.ovq-brand-txt{font-size:16px;font-weight:600;letter-spacing:1px;line-height:1;}'
   + '.ovq-brand-sub{font-size:11px;color:#888;}'
   + '.ovq-head-r{display:flex;align-items:center;justify-content:flex-end;flex:1;min-width:0;}'
   + '.ovq-lang{display:flex;gap:4px;background:var(--glass);backdrop-filter:blur(14px) saturate(160%);-webkit-backdrop-filter:blur(14px) saturate(160%);border:1px solid var(--glassBrd);border-radius:10px;padding:3px;box-shadow:var(--glassHi);}'
   + '.ovq-lang button{background:transparent;color:#999;border:none;padding:4px 10px;border-radius:6px;cursor:pointer;font-size:12px;}'
   + '.ovq-lang button.on{background:var(--g);color:#0E0E10;font-weight:600;}'
   + '.ovq-steplbl{font-size:12.5px;color:#C9C9CC;flex:0 0 auto;text-align:center;white-space:nowrap;background:var(--glass);border:1px solid var(--glassBrd);border-radius:999px;padding:5px 12px;box-shadow:var(--glassHi);}'
   + '.ovq-barwrap{height:4px;background:var(--line);}'
   + '.ovq-bar{height:100%;background:linear-gradient(90deg,var(--gd),var(--g),#FFD98A);box-shadow:0 0 12px rgba(245,166,35,.55);transition:width .3s;}'
   + '.ovq-body{padding:26px 22px;min-height:430px;}'
   + '.ovq-h3{font-size:18px;font-weight:600;margin:0 0 4px;color:#fff;}'
   + '.ovq-sub{font-size:13px;color:#9A9A9A;margin:0 0 18px;}'
   + '.ovq-grouplbl{font-size:12px;color:var(--g);text-transform:uppercase;letter-spacing:.6px;margin:14px 0 8px;}'
   + '.ovq-grid{display:grid;gap:8px;grid-template-columns:repeat(auto-fit,minmax(180px,1fr));}'
   + '.ovq-grid2{display:grid;gap:10px;grid-template-columns:repeat(auto-fit,minmax(220px,1fr));}'
   + '.ovq-stack{display:grid;gap:10px;}'
   + '.ovq-bgrid{display:grid;gap:10px;grid-template-columns:repeat(auto-fit,minmax(150px,1fr));}'
   + '.ovq-opt{text-align:left;background:var(--glass);backdrop-filter:blur(16px) saturate(160%);-webkit-backdrop-filter:blur(16px) saturate(160%);'
   + 'border:1px solid var(--glassBrd);color:#E4E4E6;border-radius:12px;cursor:pointer;box-shadow:var(--glassHi),0 4px 14px rgba(0,0,0,.25);'
   + 'font-size:14px;display:flex;align-items:center;gap:9px;padding:11px 14px;font-family:inherit;'
   + 'transition:border-color .18s,background .18s,transform .18s,box-shadow .18s;}'
   + '@media(hover:hover){.ovq-opt:hover{border-color:rgba(255,255,255,.30);transform:translateY(-2px);box-shadow:var(--glassHi),0 10px 26px rgba(0,0,0,.38);}}'
   + '.ovq-opt.on{background:linear-gradient(135deg,rgba(245,166,35,.30),rgba(245,166,35,.08));border-color:var(--g);color:#FFD98A;'
   + 'box-shadow:var(--glassHi),0 6px 22px rgba(245,166,35,.22);}'
   + '.ovq-opt.big{padding:16px;border-radius:12px;font-size:15px;gap:12px;}'
   + '.ovq-opt.budget{flex-direction:column;align-items:center;gap:8px;padding:18px 14px;border-radius:12px;font-size:15px;text-align:center;}'
   + '.ovq-optsub{font-size:12px;color:#A6A6AC;display:block;margin-top:2px;line-height:1.3;}'
   + '.ovq-opt.on .ovq-optsub{color:#F1DDB5;}'
   /* la opcion elegida en resolucion y presupuesto tambien lleva palomita (no solo color) */
   + '.ovq-mgrid .ovq-opt.big,.ovq-opt.budget{position:relative;}'
   + '.ovq-mgrid .ovq-opt.big.on::after,.ovq-opt.budget.on::after{content:"\\2713";position:absolute;top:6px;right:6px;width:20px;height:20px;border-radius:50%;background:var(--g);color:#0E0E10;font-size:12px;font-weight:800;display:flex;align-items:center;justify-content:center;}'
   + '.ovq-hzlbl{scroll-margin-top:90px;}'
   + '.ovq-ico{width:20px;height:20px;flex-shrink:0;}'
   + '.ovq-ico.big{width:24px;height:24px;}'
   + '.ovq-dico{width:18px;height:18px;object-fit:contain;vertical-align:-4px;margin-right:2px;}'
   /* ---- BLINDAJE contra el CSS del tema de Shopify ----
      La pagina envuelve el contenido en .rte, cuyo "img{height:auto;max-width:100%}"
      inflaba nuestras imagenes a tamano natural. Se fijan con id + !important. */
   + '#overdma-quiz-root .ovq-logo{height:42px !important;width:auto !important;max-width:none !important;}'
   + '#overdma-quiz-root .ovq-mascot{width:64px !important;height:64px !important;}'
   + '#overdma-quiz-root .ovq-an-mascot{width:78px !important;height:78px !important;}'
   + '#overdma-quiz-root .ovq-dico{width:18px !important;height:18px !important;}'
   + '#overdma-quiz-root .ovq-fin img{width:20px !important;height:20px !important;}'
   + '#overdma-quiz-root .ovq-ico{width:20px !important;height:20px !important;}'
   + '#overdma-quiz-root .ovq-ico.big{width:24px !important;height:24px !important;}'
   + '.ovq-note{background:linear-gradient(135deg,rgba(245,166,35,.13),rgba(245,166,35,.05));backdrop-filter:blur(14px);-webkit-backdrop-filter:blur(14px);border:1px solid rgba(245,166,35,.55);border-radius:14px;padding:18px;display:flex;align-items:center;gap:12px;font-size:14px;color:#EEE3D2;box-shadow:var(--glassHi);}'
   + '.ovq-foot{padding:16px 22px;border-top:1px solid var(--line);display:flex;align-items:center;justify-content:space-between;gap:10px;flex-wrap:wrap;}'
   + '.ovq-btn{border:1px solid var(--glassBrd);background:var(--glass);backdrop-filter:blur(12px);-webkit-backdrop-filter:blur(12px);color:#CCC;padding:9px 18px;border-radius:10px;cursor:pointer;font-size:14px;font-family:inherit;box-shadow:var(--glassHi);transition:border-color .18s,transform .18s;}'
   + '@media(hover:hover){.ovq-btn:hover{border-color:#555;transform:translateY(-1px);}}'
   + '.ovq-foot-r{display:flex;gap:10px;flex-wrap:wrap;justify-content:flex-end;}'
   + '.ovq-next{background:linear-gradient(160deg,#FFC24C,var(--g) 55%,var(--gd));border:none;color:#0E0E10;padding:9px 22px;border-radius:10px;cursor:pointer;font-size:14px;font-weight:700;font-family:inherit;box-shadow:inset 0 1px 0 rgba(255,255,255,.35),0 6px 18px rgba(245,166,35,.28);transition:transform .18s,box-shadow .18s;}'
   + '@media(hover:hover){.ovq-next:not(:disabled):not(.off):hover{transform:translateY(-1px);box-shadow:inset 0 1px 0 rgba(255,255,255,.35),0 10px 26px rgba(245,166,35,.40);}}'
   + '.ovq-next:disabled{opacity:.4;cursor:not-allowed;}'
   /* Siguiente "apagado": sigue recibiendo el toque para explicar que falta */
   + '.ovq-next.off{opacity:.5;filter:grayscale(.55);cursor:not-allowed;box-shadow:none;}'
   + '@keyframes ovqNudge{0%,100%{transform:translateX(0);}25%{transform:translateX(-5px);}50%{transform:translateX(5px);}75%{transform:translateX(-3px);}}'
   + '.ovq-next.nudge{animation:ovqNudge .35s ease;}'
   + '.ovq-hint{flex-basis:100%;order:-1;font-size:13px;font-weight:600;color:#FFD98A;text-align:center;margin:0 0 2px;}'
   + '.ovq-opt:active,.ovq-pcard:not(.dream):active,.ovq-addon.on:active,.ovq-addon.quiet:active,.ovq-btn:active{transform:scale(.985);}'
   + '.ovq-next:not(.off):active,.ovq-cta:not(:disabled):active,.ovq-mcta:not(:disabled):active{transform:scale(.97);}'
   + '.ovq-res-head{display:flex;align-items:center;gap:14px;margin-bottom:18px;background:linear-gradient(90deg,rgba(245,166,35,.14),rgba(255,255,255,.03));backdrop-filter:blur(16px);-webkit-backdrop-filter:blur(16px);border:1px solid var(--glassBrd);border-radius:16px;padding:14px 16px;box-shadow:var(--glassHi);}'
   + '.ovq-mascot{width:64px;height:64px;flex-shrink:0;object-fit:contain;}'
   + '.ovq-cards{display:flex;gap:14px;flex-wrap:wrap;margin:16px 0;}'
   + '.ovq-res-cols{display:flex;flex-direction:column;gap:4px;}'
   + '.ovq-res-side{display:flex;flex-direction:column;}'
   + '.ovq-sum{background:var(--glass);backdrop-filter:blur(20px) saturate(160%);-webkit-backdrop-filter:blur(20px) saturate(160%);'
   + 'border:1px solid var(--glassBrd);border-radius:18px;padding:16px;box-shadow:var(--glassHi),0 12px 34px rgba(0,0,0,.35);}'
   + '.ovq-sum .ovq-grouplbl{margin-top:0;}'
   + '.ovq-res-main > .ovq-note-sel{display:none;}'
   + '.ovq-pcard .ovq-note{margin-top:12px;padding:12px;font-size:12.5px;gap:10px;align-items:flex-start;}'
   + '.ovq-pcard{flex:1;min-width:230px;background:var(--glass);backdrop-filter:blur(20px) saturate(160%);-webkit-backdrop-filter:blur(20px) saturate(160%);'
   + 'border:1px solid var(--glassBrd);border-radius:18px;padding:18px;cursor:pointer;box-shadow:var(--glassHi),0 10px 30px rgba(0,0,0,.35);'
   + 'transition:border-color .18s,transform .18s,box-shadow .18s;}'
   + '@media(hover:hover){.ovq-pcard:hover{transform:translateY(-3px);border-color:rgba(255,255,255,.28);}}'
   + '.ovq-pcard.on{border:1px solid var(--g);background:linear-gradient(160deg,rgba(245,166,35,.14),rgba(245,166,35,.03) 55%,var(--glass));'
   + 'box-shadow:var(--glassHi),0 0 0 1px var(--g),0 14px 40px rgba(245,166,35,.20);}'
   + '.ovq-pcard[data-card=dream]:not(.on){border-color:rgba(245,166,35,.50);'
   + 'box-shadow:var(--glassHi),0 10px 30px rgba(245,166,35,.14);}'
   + '.ovq-tag{display:inline-block;background:#222;color:#999;font-size:11px;padding:4px 10px;border-radius:6px;}'
   + '.ovq-tag.acc{background:rgba(245,166,35,.15);color:var(--g);}'
   + '.ovq-line{display:flex;justify-content:space-between;font-size:12.5px;padding:5px 0;border-bottom:1px solid #232326;color:#CCC;gap:8px;}'
   + '.ovq-line span:last-child{color:#999;white-space:nowrap;}'
   + '.ovq-line span:first-child{flex:1;min-width:0;}'
   + '.ovq-ptot{display:flex;justify-content:space-between;margin-top:12px;font-size:15px;font-weight:600;color:#fff;}'
   + '.ovq-ptot span:last-child{color:var(--g);}'
   + '.ovq-fit{font-size:11px;padding:4px 9px;border-radius:6px;margin-top:11px;display:inline-block;}'
   + '.ovq-fit.ok{background:rgba(95,210,126,.14);color:var(--ok);}'
   + '.ovq-fit.over{background:rgba(245,166,35,.12);color:var(--g);}'
   + '.ovq-save{display:block;font-size:12px;font-weight:600;color:var(--ok);background:rgba(95,210,126,.12);border-radius:6px;padding:6px 10px;margin-top:10px;}'
   + '.ovq-inct{font-size:11px;color:var(--g);text-transform:uppercase;letter-spacing:.5px;margin:12px 0 6px;}'
   /* "Incluye" en chips: la misma info en 2-3 renglones en vez de 7 */
   + '.ovq-incs{display:flex;flex-wrap:wrap;gap:5px;}'
   + '.ovq-inc{display:inline-flex;align-items:center;gap:5px;font-size:11.5px;color:#D2D2D6;line-height:1.3;'
   + 'background:rgba(255,255,255,.045);border:1px solid rgba(255,255,255,.08);border-radius:999px;padding:3px 9px;}'
   + '.ovq-inc .ck{color:var(--ok);font-weight:700;flex-shrink:0;}'
   + '.ovq-ctitle{font-size:15px;margin:0 0 12px;color:#fff;font-weight:600;}'
   /* Paso del monitor: rejilla de resolucion y de Hz */
   + '.ovq-mgrid{display:grid;gap:10px;grid-template-columns:repeat(auto-fit,minmax(150px,1fr));}'
   /* Grupos del resultado: recomendados | o | DREAM. Apilados por defecto; en una
      fila cuando el quiz es ancho (ver @container). */
   + '.ovq-cards.tiers{display:flex;flex-direction:column;gap:18px;}'
   + '.ovq-grp{min-width:0;}'
   + '.ovq-grp-t{font-size:11.5px;font-weight:700;letter-spacing:1.4px;text-transform:uppercase;color:#9A9AA2;margin:0 0 24px;}'
   + '.ovq-grp-t.dr{color:var(--g);}'
   + '.ovq-grp-cards{display:flex;gap:16px;flex-wrap:wrap;align-items:stretch;}'
   + '.ovq-grp-cards .ovq-pcard{flex:1;}'
   + '.ovq-sep{display:flex;align-items:center;gap:12px;color:var(--g);font-size:12px;font-weight:700;letter-spacing:1.5px;text-transform:uppercase;}'
   + '.ovq-sep::before,.ovq-sep::after{content:"";flex:1;height:1px;background:linear-gradient(90deg,transparent,rgba(245,166,35,.6),transparent);}'
   + '.ovq-sep span{padding:5px 13px;border:1px solid rgba(245,166,35,.45);border-radius:999px;background:rgba(245,166,35,.08);}'
   /* ---- DREAM: la joya de la corona ----
      Cinta sobre el borde, borde de luz dorada que gira, brillo, fondo premium,
      titulo y precio en oro. Sin movimiento si el usuario lo pide (reduced-motion). */
   + '@property --ovqAng{syntax:"<angle>";inherits:false;initial-value:0deg;}'
   + '@keyframes ovqSpin{to{--ovqAng:360deg;}}'
   + '@keyframes ovqSheen{0%{background-position:140% 0;}55%,100%{background-position:-40% 0;}}'
   + '.ovq-pcard.dream{position:relative;overflow:visible;border-color:transparent !important;'
   + 'background:radial-gradient(130% 90% at 50% -10%,rgba(245,166,35,.22),transparent 58%),linear-gradient(180deg,#1a150d,#100e0b);'
   + 'box-shadow:0 0 0 1px rgba(245,166,35,.25),0 0 44px rgba(245,166,35,.22),0 24px 60px rgba(0,0,0,.55);transform:translateY(-4px);}'
   + '.ovq-pcard.dream::before{--ovqAng:0deg;content:"";position:absolute;inset:-2px;border-radius:20px;padding:2px;pointer-events:none;'
   + 'background:conic-gradient(from var(--ovqAng),#F5A623,#FFE7A8,#C8821A,#5c3a08,#F5A623);'
   + '-webkit-mask:linear-gradient(#000 0 0) content-box,linear-gradient(#000 0 0);-webkit-mask-composite:xor;'
   + 'mask:linear-gradient(#000 0 0) content-box,linear-gradient(#000 0 0);mask-composite:exclude;animation:ovqSpin 4.5s linear infinite;}'
   /* brillo que cruza: vive DENTRO de la tarjeta (inset:0 + background que se mueve),
      asi no se sale por los lados aunque la tarjeta deje ver la cinta de arriba */
   + '.ovq-pcard.dream::after{content:"";position:absolute;inset:0;border-radius:18px;pointer-events:none;'
   + 'background:linear-gradient(105deg,transparent 40%,rgba(255,231,168,.11) 50%,transparent 60%);background-size:260% 100%;'
   + 'animation:ovqSheen 5.5s ease-in-out infinite;}'
   + '@media(hover:hover){.ovq-pcard.dream:hover{transform:translateY(-7px);}}'
   + '.ovq-dream-rib{position:absolute;top:-13px;left:50%;transform:translateX(-50%);z-index:2;white-space:nowrap;'
   + 'background:linear-gradient(160deg,#FFE7A8,#F5A623 45%,#C8821A);color:#1a1206;font-size:11.5px;font-weight:800;letter-spacing:1.6px;'
   + 'padding:5px 14px;border-radius:999px;box-shadow:0 6px 18px rgba(245,166,35,.45),inset 0 1px 0 rgba(255,255,255,.55);}'
   + '.ovq-pcard.dream .ovq-ctitle{font-size:18px;font-weight:800;background:linear-gradient(95deg,#FFE7A8,#F5A623 55%,#C8821A);'
   + '-webkit-background-clip:text;background-clip:text;color:transparent;}'
   + '.ovq-pcard.dream .ovq-ptot span:last-child{font-size:19px;}'
   + '.ovq-why{display:grid;gap:6px;}'
   + '.ovq-why-i{display:flex;gap:8px;align-items:flex-start;font-size:12px;color:#E9DFC9;line-height:1.4;}'
   + '.ovq-why-i .st{color:var(--g);flex-shrink:0;}'
   + '@media (prefers-reduced-motion: reduce){.ovq-pcard.dream::before,.ovq-pcard.dream::after{animation:none;}}'
   + '.ovq-addon{background:var(--glass);backdrop-filter:blur(16px) saturate(160%);-webkit-backdrop-filter:blur(16px) saturate(160%);border:1px solid var(--line);border-radius:14px;padding:16px;margin-bottom:10px;cursor:pointer;box-shadow:var(--glassHi);}'
   /* Llamado de atencion del servicio de instalacion: borde dorado que respira +
      vibracion corta cada ~3.5s. Al marcarlo (.on) se detiene todo (ya convencio). */
   + '@keyframes ovqGlow{0%,100%{box-shadow:0 0 0 0 rgba(245,166,35,.55);}50%{box-shadow:0 0 14px 3px rgba(245,166,35,.25);}}'
   + '@keyframes ovqShake{0%,86%,100%{transform:translateX(0) rotate(0);}88%{transform:translateX(-3px) rotate(-.4deg);}90%{transform:translateX(3px) rotate(.4deg);}92%{transform:translateX(-3px);}94%{transform:translateX(3px);}96%{transform:translateX(-2px);}98%{transform:translateX(2px);}}'
   + '.ovq-addon:not(.on){border-color:var(--g);animation:ovqGlow 2.2s ease-in-out infinite, ovqShake 3.5s ease-in-out infinite;}'
   + '.ovq-addon.quiet:not(.on){border-color:var(--glassBrd);animation:none;box-shadow:var(--glassHi);}'
   + '.ovq-sold{display:inline-block;font-size:11px;font-weight:700;color:#FF8A80;background:rgba(226,75,74,.14);'
   + 'border:1px solid rgba(226,75,74,.45);border-radius:6px;padding:1px 6px;margin-left:6px;vertical-align:1px;}'
   + '@media (prefers-reduced-motion: reduce){.ovq-addon:not(.on){animation:none;box-shadow:0 0 10px 2px rgba(245,166,35,.3);}}'
   + '.ovq-addon-badge{display:inline-block;background:var(--g);color:#0E0E10;font-size:10.5px;font-weight:700;'
   + 'padding:2px 8px;border-radius:20px;margin-left:8px;letter-spacing:.4px;vertical-align:middle;white-space:nowrap;}'
   + '.ovq-addon.on{background:rgba(245,166,35,.08);border-color:var(--g);}'
   + '.ovq-addon-row{display:flex;justify-content:space-between;align-items:center;gap:12px;}'
   + '.ovq-addon-l{display:flex;align-items:flex-start;gap:11px;}'
   + '.ovq-addon-price{font-size:15px;color:var(--g);font-weight:600;white-space:nowrap;}'
   + '.ovq-addon-t{font-size:14px;color:#fff;}'
   + '.ovq-addon-opt{color:#A6A6AC;font-size:12px;}'
   + '.ovq-addon-desc{font-size:12.5px;color:#A6A6AC;margin-top:3px;line-height:1.4;}'
   + '.ovq-addon-badge.off{visibility:hidden;}'
   + '.ovq-ordertot{display:flex;justify-content:space-between;align-items:center;gap:10px;flex-wrap:wrap;background:var(--glass);backdrop-filter:blur(14px);-webkit-backdrop-filter:blur(14px);border:1px solid var(--glassBrd);border-radius:14px;padding:16px 18px;margin-top:14px;box-shadow:var(--glassHi);}'
   + '.ovq-ordertot .l{font-size:15px;color:#fff;font-weight:600;}'
   + '.ovq-ordertot .v{font-size:20px;color:var(--g);font-weight:600;white-space:nowrap;margin-left:auto;}'
   /* que se esta comprando (el panel solo decia 'Total de la orden') */
   + '.ovq-pick{display:flex;align-items:baseline;gap:8px;font-size:13px;color:#A6A6AC;margin:0 0 12px;padding:0 0 12px;border-bottom:1px solid var(--line);}'
   + '.ovq-pick b{color:#fff;font-weight:600;flex:1;min-width:0;}'
   + '.ovq-pick .p{color:var(--g);font-weight:600;white-space:nowrap;}'
   + '.ovq-err a{color:inherit;font-weight:700;text-decoration:underline;}'
   + '.ovq-err.ovq-slow{border-color:rgba(245,166,35,.5);background:rgba(245,166,35,.1);color:#FFD98A;}'
   + '.ovq-err{margin:10px 0 0;padding:10px 12px;border-radius:10px;border:1px solid rgba(226,75,74,.5);background:rgba(226,75,74,.12);color:#FFB4AE;font-size:13px;line-height:1.4;}'
   + '.ovq-cta{width:100%;margin-top:12px;background:linear-gradient(160deg,#FFC24C,var(--g) 55%,var(--gd));border:none;color:#0E0E10;'
   + 'padding:14px;border-radius:14px;cursor:pointer;font-size:15.5px;font-weight:700;font-family:inherit;letter-spacing:.2px;'
   + 'box-shadow:inset 0 1px 0 rgba(255,255,255,.40),0 10px 30px rgba(245,166,35,.30);transition:transform .18s,box-shadow .18s;}'
   + '@media(hover:hover){.ovq-cta:not(:disabled):hover{transform:translateY(-2px);box-shadow:inset 0 1px 0 rgba(255,255,255,.40),0 14px 38px rgba(245,166,35,.45);}}'
   + '.ovq-cta:disabled{opacity:.6;cursor:wait;}'
   + '.ovq-fin{display:flex;align-items:center;gap:9px;font-size:12.5px;color:#F0DBB6;font-weight:500;margin-top:14px;'
   + 'background:rgba(245,166,35,.1);border:1px solid rgba(245,166,35,.4);border-radius:10px;padding:11px 14px;line-height:1.35;}'
   + '.ovq-fin img{width:20px;height:20px;object-fit:contain;flex-shrink:0;}'
   + '.ovq-mbar,.ovq-mbar-w{display:none;}'
   + '.ovq-mbar-t{display:flex;flex-direction:column;min-width:0;flex:1 1 auto;line-height:1.2;}'
   + '.ovq-mbar-t small{font-size:12px;color:#A6A6AC;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}'
   + '.ovq-mbar-t b{font-size:19px;color:var(--g);font-weight:700;}'
   + '.ovq-mcta{flex:0 0 auto;min-height:48px;padding:12px 18px;border:none;border-radius:12px;cursor:pointer;font-family:inherit;font-size:15px;font-weight:700;color:#0E0E10;'
   + 'background:linear-gradient(160deg,#FFC24C,var(--g) 55%,var(--gd));box-shadow:inset 0 1px 0 rgba(255,255,255,.40),0 8px 22px rgba(245,166,35,.30);}'
   + '.ovq-mcta:disabled{opacity:.6;cursor:wait;}'
   + '.ovq-talk{background:#5865F2 !important;border-color:#5865F2 !important;color:#fff !important;font-weight:600;}'
   + '@media(hover:hover){.ovq-talk:hover{background:#4752C4 !important;border-color:#4752C4 !important;}}'
   /* ---- Pantalla "Analizando" ---- */
   + '.ovq-an{display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;min-height:430px;gap:16px;padding:24px;}'
   + '.ovq-an-glow{position:relative;display:flex;align-items:center;justify-content:center;}'
   + '.ovq-an-glow::before{content:"";position:absolute;width:96px;height:96px;border-radius:50%;background:radial-gradient(circle,rgba(245,166,35,.35),transparent 70%);animation:ovqPulse 1.6s ease-in-out infinite;}'
   + '.ovq-an-mascot{position:relative;width:78px;height:78px;object-fit:contain;animation:ovqFloat 2s ease-in-out infinite;}'
   + '.ovq-an-t{font-size:18px;font-weight:600;color:#fff;margin-top:4px;}'
   + '.ovq-an-msg{font-size:13.5px;color:var(--g);min-height:18px;}'
   + '.ovq-an-track{width:100%;max-width:300px;height:5px;background:var(--line);border-radius:3px;overflow:hidden;}'
   + '.ovq-an-bar{height:100%;width:0;background:linear-gradient(90deg,var(--gd),var(--g));border-radius:3px;transition:width .55s ease;}'
   /* ---- Modo inline: quiz anclado como contenido de la pagina ---- */
   + '#overdma-quiz-inline{display:block;max-width:680px;margin:28px auto 48px;padding:0 14px;}'
   + '@media(max-width:520px){#overdma-quiz-inline{margin:0 auto 32px;padding:0;}}'
   /* ---- ESCRITORIO (>=900px): el quiz aprovecha la pantalla completa ----
      Contenedor ancho, opciones en rejilla multi-columna y tarjetas del
      resultado lado a lado. El movil queda exactamente igual. */
   /* ---- CONTENEDOR DE CONSULTA (@container) ----------------------------
      BUG REAL EN PRODUCCION: el layout de escritorio se activaba por el ancho
      de la VENTANA, no del quiz. En el modal flotante (680px) entraba el grid
      de 2 columnas con barra lateral de 360px, no cabia, y las tarjetas se
      encimaban con el panel del carrito. Ahora el quiz se declara contenedor y
      su layout interno responde a SU PROPIO ancho: inline ancho -> 2 columnas;
      modal angosto -> apilado. Imposible que se vuelvan a encimar. */
   + '.ovq-shell{container-type:inline-size;container-name:ovq;}'
   /* Ancho del contenedor (vive FUERA del quiz -> sigue por viewport).
      La regla del modal lleva 2 clases a proposito: le gana por especificidad
      a la base de mas abajo, que antes la anulaba por orden de cascada. */
   + '@media(min-width:900px){'
   +   '#overdma-quiz-inline{max-width:1480px;margin:36px auto 64px;padding:0 24px;}'
   +   '.ovw-modal .ovw-modal-inner{max-width:1360px;}'
   + '}'
   /* Sin soporte de @container (navegadores viejos): una sola columna comoda */
   + '@supports not (container-type:inline-size){#overdma-quiz-inline{max-width:820px;}}'
   /* ---- Layout interno: depende del ancho del PROPIO quiz ---- */
   + '@container ovq (min-width:900px){'
   +   '.ovq-head{padding:20px 44px;}'
   +   '.ovq-body{padding:36px 44px 30px;min-height:480px;}'
   +   '.ovq-foot{padding:16px 44px 22px;}'
   +   '.ovq-h3{font-size:23px;}'
   +   '.ovq-sub{font-size:14.5px;margin-bottom:24px;}'
   +   '.ovq-grouplbl{font-size:12.5px;margin:18px 0 10px;}'
   +   '.ovq-grid{grid-template-columns:repeat(auto-fill,minmax(190px,1fr));gap:10px;}'
   +   '.ovq-grid2{grid-template-columns:repeat(auto-fit,minmax(200px,1fr));gap:12px;}'
   +   '.ovq-stack{grid-template-columns:repeat(auto-fit,minmax(280px,1fr));gap:12px;}'
   +   '.ovq-bgrid{grid-template-columns:repeat(4,1fr);gap:12px;}'
   +   '.ovq-opt{font-size:14.5px;padding:12px 15px;}'
   +   '.ovq-opt.big{padding:18px;font-size:15.5px;}'
   +   '.ovq-cards{gap:16px;}'
   +   '.ovq-pcard{min-width:258px;padding:22px;}'
   +   '.ovq-res-head{padding:16px 20px;gap:16px;}'
   +   '.ovq-res-cols{display:grid;grid-template-columns:minmax(0,1fr) minmax(300px,340px);gap:20px;align-items:start;}'
   +   '.ovq-res-side{position:sticky;top:16px;}'
   +   '.ovq-cards{margin-top:0;}'
   +   '.ovq-cta{padding:15px;font-size:16px;}'
   + '}'
   /* Quiz ancho: recomendados | o | DREAM en UNA fila, divisor vertical */
   + '@container ovq (min-width:1300px){'
   +   '.ovq-cards.tiers{flex-direction:row;align-items:stretch;gap:0;}'
   +   '.ovq-grp-rec{flex:2 1 0;}'
   +   '.ovq-grp-dream{flex:1 1 0;}'
   +   '.ovq-grp{display:flex;flex-direction:column;}'
   +   '.ovq-grp-cards{flex:1;flex-wrap:nowrap;}'
   +   '.ovq-grp-cards .ovq-pcard{min-width:0;}'
   +   '.ovq-sep{flex-direction:column;justify-content:center;padding:40px 14px 0;}'
   +   '.ovq-sep::before,.ovq-sep::after{width:2px;height:auto;background:linear-gradient(180deg,rgba(245,166,35,.08),rgba(245,166,35,.85),rgba(245,166,35,.08));}'
   + '}'
   + '@media(pointer:coarse){.ovq-next,.ovq-cta,.ovq-btn{min-height:44px;}.ovq-lang button{min-height:34px;min-width:40px;}}'
   + '@container ovq (max-width:639px){.ovq-cards,.ovq-grp-cards{flex-direction:column;}.ovq-pcard{min-width:0;}}'
   + '@container ovq (min-width:900px){.ovq-res-main > .ovq-note-sel{display:flex;}.ovq-pcard .ovq-note-sel{display:none;}}'
   + '@media(max-width:520px){'
   +   '.ovq-head{gap:8px;padding:10px 14px;}'
   +   '.ovw-modal-inner .ovq-head{padding-right:62px;}'
   +   '#overdma-quiz-root .ovq-logo{height:30px !important;}.ovq-brand-txt,.ovq-brand-sub{display:none;}'
   +   '.ovq-brand{flex:1 1 auto;}.ovq-head-r{flex:0 0 auto;gap:8px;}'
   +   '.ovq-steplbl{padding:6px 11px;font-size:12.5px;}'
   /* ES/EN: 34x22 era un blanco minimo pegado al boton de cerrar */
   +   '.ovq-lang{gap:4px;padding:3px;}.ovq-lang button{min-width:44px;min-height:40px;padding:6px 10px;font-size:13px;border-radius:8px;}'
   /* sin backdrop-filter en telefono: sobre fondo oscuro no se ve y hace ir a tirones el scroll */
   +   '.ovq-opt,.ovq-pcard,.ovq-addon,.ovq-sum,.ovq-ordertot,.ovq-note,.ovq-btn,.ovq-res-head{backdrop-filter:none;-webkit-backdrop-filter:none;}'
   +   '.ovq-body{padding:20px 16px;min-height:0;}'
   /* pie fijo abajo: Atras / Siguiente siempre a mano */
   +   '.ovw-modal-inner .ovq-head{position:sticky;top:0;z-index:5;background:#0E0E12;}'
   +   '.ovq-foot{position:sticky;bottom:0;z-index:4;gap:8px;background:#0B0B0E;padding:10px 16px calc(10px + env(safe-area-inset-bottom,0px));}'
   +   '.ovq-foot:not(.ovq-foot-res) .ovq-foot-r{flex:1 1 auto;}.ovq-foot:not(.ovq-foot-res) .ovq-next{width:100%;}'
   +   '.ovq-foot.ovq-first .ovq-back{display:none;}'
   /* resultado: acciones en rejilla 2x2 (y el pie deja de ser fijo: ahi manda la barra del carrito) */
   +   '.ovq-foot.ovq-foot-res{position:static;display:grid;grid-template-columns:1fr 1fr;background:transparent;padding:14px 16px calc(16px + env(safe-area-inset-bottom,0px));}'
   +   '.ovq-foot-res .ovq-foot-r{display:contents;}.ovq-foot-res .ovq-btn{width:100%;text-align:center;padding:10px 8px;}'
   +   '.ovq-btn{min-height:44px;padding:10px 14px;font-size:13.5px;}'
   +   '.ovq-next{min-height:48px;padding:10px 20px;font-size:15px;}'
   +   '.ovq-nogame{min-height:48px;}'
   +   '.ovq-h3{font-size:18px;line-height:1.25;}.ovq-sub{font-size:13.5px;line-height:1.45;}'
   +   '.ovq-grouplbl{font-size:12.5px;margin:16px 0 8px;}'
   +   '.ovq-grid{grid-template-columns:repeat(auto-fit,minmax(148px,1fr));gap:8px;}'
   +   '.ovq-opt{font-size:14px;padding:11px 12px;min-height:48px;}.ovq-opt.big{padding:14px;font-size:15px;min-height:56px;}'
   +   '.ovq-optsub{font-size:12.5px;}'
   +   '.ovq-mgrid{grid-template-columns:1fr 1fr;grid-auto-rows:1fr;gap:8px;}.ovq-mgrid .ovq-opt.big{padding:12px 10px;gap:8px;}'
   +   '.ovq-bgrid{grid-template-columns:1fr 1fr;gap:8px;}.ovq-opt.budget{padding:14px 10px;min-height:76px;}'
   +   '.ovq-res-head{padding:12px;gap:11px;}#overdma-quiz-root .ovq-mascot{width:50px !important;height:50px !important;}'
   +   '.ovq-pcard{padding:16px;min-width:0;}.ovq-cards{gap:12px;flex-direction:column;}'
   +   '.ovq-grp-cards{flex-direction:column;gap:12px;}'
   /* tipografia minima legible (habia textos de 10-11.5px) */
   +   '.ovq-grp-t{font-size:12.5px;letter-spacing:.9px;margin-bottom:22px;}'
   +   '.ovq-inct{font-size:12.5px;letter-spacing:.4px;margin:14px 0 8px;}'
   /* INCLUYE: una linea por producto (Over: 'MAKCU debe ir debajo de la DMA, no al lado') */
   +   '.ovq-incs{display:grid;grid-template-columns:1fr;gap:7px;}'
   +   '.ovq-inc{display:flex;align-items:flex-start;gap:9px;background:transparent;border:0;border-radius:0;padding:0;font-size:14px;line-height:1.35;color:#DDDDE2;}'
   +   '.ovq-inc .ck{width:16px;flex:0 0 16px;text-align:center;}'
   +   '.ovq-tag{font-size:12px;padding:5px 10px;}'
   +   '.ovq-line{font-size:13.5px;padding:7px 0;}'
   +   '.ovq-fit{font-size:12.5px;padding:6px 10px;margin-top:12px;font-weight:600;}'
   +   '.ovq-save{font-size:13px;}.ovq-why-i{font-size:13.5px;}.ovq-sep{font-size:12.5px;}'
   +   '.ovq-dream-rib{font-size:12px;letter-spacing:1.2px;padding:6px 14px;}'
   +   '.ovq-pcard.dream::after{animation-iteration-count:2;}'
   +   '.ovq-addon-badge{font-size:12px;padding:3px 8px;margin:5px 0 0;}'
   +   '.ovq-sold{font-size:11.5px;padding:2px 7px;}'
   +   '.ovq-note{padding:14px;font-size:13.5px;line-height:1.45;align-items:flex-start;}'
   +   '.ovq-pcard .ovq-note{font-size:13px;}'
   +   '.ovq-fin{font-size:13px;}'
   +   '.ovq-sum{padding:14px;}.ovq-pick{font-size:13.5px;}'
   +   '.ovq-ordertot{padding:13px 15px;}.ovq-ordertot .v{font-size:19px;}.ovq-ordertot .l{font-size:14.5px;}'
   +   '.ovq-cta{padding:13px;font-size:15.5px;min-height:50px;}'
   /* add-ons: texto a lo ancho y precio arriba a la derecha */
   +   '.ovq-addon{padding:14px;}.ovq-addon-row{display:grid;grid-template-columns:minmax(0,1fr) auto;align-items:start;column-gap:10px;}'
   +   '.ovq-addon-l{min-width:0;}.ovq-addon-t{font-size:15px;}.ovq-addon-desc{font-size:13px;}.ovq-addon-opt{font-size:12.5px;}'
   /* barra fija: total + Anadir al carrito siempre a la vista en el resultado */
   +   '.ovq-mbar-w{display:block;position:sticky;bottom:0;height:0;z-index:4;}'
   +   '.ovq-mbar{display:flex;align-items:center;gap:12px;position:absolute;left:-16px;right:-16px;bottom:0;'
   +   'padding:10px 16px calc(10px + env(safe-area-inset-bottom,0px));background:#0D0D10;border-top:1px solid rgba(245,166,35,.35);'
   +   'box-shadow:0 -10px 24px rgba(0,0,0,.45);transition:transform .2s ease,opacity .2s ease;}'
   +   '.ovq-mbar.hide{transform:translateY(110%);opacity:0;pointer-events:none;}'
   + '}'
   + '@media(max-width:340px){'
   +   '.ovq-lang button{min-width:40px;padding:6px 8px;font-size:12px;}.ovq-steplbl{padding:5px 9px;font-size:12px;}'
   +   '.ovq-body{padding:18px 12px;}.ovq-mbar{left:-12px;right:-12px;padding-left:12px;padding-right:12px;}'
   +   '.ovq-foot-res .ovq-copy,.ovq-foot-res .ovq-talk{grid-column:1 / -1;}.ovq-mcta{padding:12px 14px;font-size:14px;}'
   + '}'
   /* telefono en horizontal: poca altura -> cabecera compacta, pie fijo y barra del carrito */
   + '@media(max-height:520px){'
   +   '.ovq-head{padding:8px 16px;gap:8px;}#overdma-quiz-root .ovq-logo{height:28px !important;}.ovq-brand-sub{display:none;}'
   +   '.ovq-body{padding:16px 20px 18px;}'
   +   '.ovq-foot{position:sticky;bottom:0;z-index:4;background:#0B0B0E;padding:8px 20px;}'
   +   '.ovq-foot.ovq-foot-res{position:static;background:transparent;}'
   +   '.ovq-mbar-w{display:block;position:sticky;bottom:0;height:0;z-index:4;}'
   +   '.ovq-mbar{display:flex;align-items:center;gap:12px;position:absolute;left:-20px;right:-20px;bottom:0;padding:8px 20px;'
   +   'background:#0D0D10;border-top:1px solid rgba(245,166,35,.35);transition:transform .2s ease,opacity .2s ease;}'
   +   '.ovq-mbar.hide{transform:translateY(110%);opacity:0;pointer-events:none;}'
   + '}'
   + '@media(max-height:600px){.ovq-body,.ovq-an{min-height:0;}}'
   + '@media(max-height:520px){.ovw-modal-inner .ovq-res-side{top:58px;}}'
   /* ---- Launcher flotante (burbuja + globito) ---- */
   + '#overdma-widget{--g:#F5A623;--gd:#C8821A;--dark:#0E0E10;--card:#1A1A1D;--line:#2A2A2E;'
   + 'font-family:Inter,system-ui,-apple-system,Segoe UI,Roboto,Arial,sans-serif;}'
   + '#overdma-widget *{box-sizing:border-box;}'
   + '.ovw-launch{position:fixed;right:calc(22px + env(safe-area-inset-right,0px));bottom:calc(22px + env(safe-area-inset-bottom,0px));z-index:2147483000;display:flex;align-items:flex-end;flex-direction:row-reverse;gap:12px;}'
   + '.ovw-bub{position:relative;width:66px;height:66px;border-radius:50%;border:none;cursor:pointer;padding:0;'
   + 'background:radial-gradient(circle at 50% 38%,#2a2a2e,#161618);box-shadow:0 8px 28px rgba(0,0,0,.45),0 0 0 1px rgba(245,166,35,.35);'
   + 'transition:transform .2s,box-shadow .2s;animation:ovwIn .4s ease both;}'
   + '@media(hover:hover){.ovw-bub:hover{transform:translateY(-3px) scale(1.04);box-shadow:0 12px 34px rgba(0,0,0,.55),0 0 0 2px rgba(245,166,35,.6);}}'
   + '.ovw-bub img{position:absolute;inset:0;width:100%;height:100%;object-fit:contain;padding:6px;z-index:2;transform-origin:50% 58%;animation:ovwWiggle 3.6s ease-in-out infinite;}'
   + '.ovw-bub::before{content:"";position:absolute;inset:0;border-radius:50%;border:2px solid var(--g);opacity:0;pointer-events:none;animation:ovwWave 3s ease-out infinite;}'
   + '.ovw-bub::after{content:"";position:absolute;inset:0;border-radius:50%;border:2px solid var(--g);opacity:0;pointer-events:none;animation:ovwWave 3s ease-out infinite;animation-delay:.5s;}'
   + '.ovw-ping{position:absolute;top:4px;right:4px;width:13px;height:13px;border-radius:50%;background:var(--g);border:2px solid #0E0E10;z-index:3;}'
   + '.ovw-ping::after{content:"";position:absolute;inset:-2px;border-radius:50%;background:var(--g);opacity:.6;animation:ovwPing 1.8s ease-out infinite;}'
   + '.ovw-tip{position:relative;max-width:248px;background:#1A1A1D;border:1px solid var(--line);border-radius:14px 14px 4px 14px;'
   + 'padding:13px 42px 13px 15px;box-shadow:0 10px 30px rgba(0,0,0,.4);animation:ovwTipIn .35s ease both;cursor:pointer;}'
   + '.ovw-tip-t{font-size:13.5px;font-weight:600;color:#fff;margin-bottom:2px;}'
   + '.ovw-tip-m{font-size:12px;color:#B7B7B7;line-height:1.4;}'
   + '.ovw-tip-x{position:absolute;top:2px;right:2px;width:36px;height:36px;display:flex;align-items:center;justify-content:center;background:none;border:none;color:#B5B5B5;font-size:20px;cursor:pointer;line-height:1;padding:0;border-radius:50%;}'
   + '@media(hover:hover){.ovw-tip-x:hover{color:#fff;}}'
   + '.ovw-tip-cta{display:inline-flex;align-items:center;gap:5px;margin-top:8px;background:var(--g);color:#0E0E10;'
   + 'font-size:12px;font-weight:700;padding:5px 12px;border-radius:7px;}'
   + '.ovw-hidden{display:none !important;}'
   + '.ovw-open .ovw-launch{visibility:hidden;}'
   /* ---- Modal overlay ---- */
   + '.ovw-modal{position:fixed;inset:0;z-index:2147483001;display:flex;align-items:center;justify-content:center;'
   + 'background:rgba(0,0,0,.72);backdrop-filter:blur(4px);-webkit-backdrop-filter:blur(4px);padding:20px;animation:ovwFade .25s ease backwards;}'
   + '.ovw-modal-inner{position:relative;width:100%;max-width:680px;max-height:92vh;max-height:92dvh;overflow-y:auto;overscroll-behavior:contain;-webkit-overflow-scrolling:touch;animation:ovwPop .3s cubic-bezier(.2,.8,.3,1.1) backwards;'
   + 'border-radius:16px;box-shadow:0 30px 80px rgba(0,0,0,.6);scrollbar-width:thin;scrollbar-color:var(--gd) rgba(255,255,255,.04);}'
   + '.ovw-modal-inner::-webkit-scrollbar{width:10px;}'
   + '.ovw-modal-inner::-webkit-scrollbar-track{background:rgba(255,255,255,.04);border-radius:0 16px 16px 0;}'
   + '.ovw-modal-inner::-webkit-scrollbar-thumb{background:rgba(245,166,35,.5);border-radius:8px;border:2px solid transparent;background-clip:content-box;}'
   + '.ovw-modal-inner::-webkit-scrollbar-thumb:hover{background:var(--g);background-clip:content-box;}'
   + '.ovw-stick{position:sticky;top:0;height:0;z-index:6;}'
   + '.ovw-close{position:absolute;top:14px;right:14px;z-index:5;width:34px;height:34px;border-radius:50%;border:1px solid var(--line);'
   + 'background:rgba(20,20,22,.85);color:#CCC;cursor:pointer;font-size:18px;line-height:1;display:flex;align-items:center;justify-content:center;}'
   + '@media(hover:hover){.ovw-close:hover{color:#fff;border-color:#666;}}'
   + '@keyframes ovwIn{from{opacity:0;transform:scale(.6);}to{opacity:1;transform:scale(1);}}'
   + '@keyframes ovwTipIn{from{opacity:0;transform:translateX(8px) translateY(4px);}to{opacity:1;transform:none;}}'
   + '@keyframes ovwPing{0%{transform:scale(1);opacity:.6;}100%{transform:scale(2.4);opacity:0;}}'
   + '@keyframes ovwWave{0%{transform:scale(.92);opacity:.55;}55%{transform:scale(1.85);opacity:0;}100%{transform:scale(1.85);opacity:0;}}'
   + '@keyframes ovwWiggle{0%,79%,100%{transform:rotate(0);}83%{transform:rotate(-8deg);}87%{transform:rotate(7deg);}91%{transform:rotate(-5deg);}95%{transform:rotate(3deg);}}'
   + '@keyframes ovwFade{from{opacity:0;}to{opacity:1;}}'
   + '@keyframes ovwPop{from{opacity:0;transform:translateY(16px) scale(.97);}to{opacity:1;transform:none;}}'
   + '@keyframes ovqPulse{0%,100%{opacity:.5;transform:scale(.9);}50%{opacity:1;transform:scale(1.15);}}'
   + '@keyframes ovqFloat{0%,100%{transform:translateY(0);}50%{transform:translateY(-6px);}}'
   + '@media(max-width:520px){.ovw-launch{right:calc(16px + env(safe-area-inset-right,0px));bottom:calc(16px + env(safe-area-inset-bottom,0px));}.ovw-tip{max-width:230px;}}'
   /* PANTALLA COMPLETA en telefono (vertical y horizontal). Caso real 2026-09 (iPhone de
      Over): al fondo del modal se veia la tienda. El overlay era 72% transparente, la caja
      del quiz no tenia fondo propio y iOS no respeta overflow:hidden en <html>, asi que la
      pagina de atras se movia y asomaba (rebote, barra de Safari). Ahora: overlay y caja
      opacos, la caja rellena el overlay (sin 100dvh centrado), scroll de la pagina
      bloqueado de verdad (JS) y la tienda no se pinta mientras el quiz esta abierto. */
   + '@media(max-width:520px),(max-height:520px){'
   +   '.ovw-modal{padding:0;align-items:stretch;justify-content:stretch;background:#0A0A0D;backdrop-filter:none;-webkit-backdrop-filter:none;}'
   +   '.ovw-modal .ovw-modal-inner{max-width:none;width:100%;height:auto;max-height:none;border-radius:0;box-shadow:none;background:linear-gradient(180deg,#111116,#0A0A0D);}'
   +   '.ovw-modal-inner .ovq-shell{border-radius:0;border:0;box-shadow:none;min-height:100%;overflow:visible;display:flex;flex-direction:column;}'
   +   '.ovw-modal-inner .ovq-body{flex:1 0 auto;}'
   +   '.ovw-close{width:44px;height:44px;top:6px;right:6px;font-size:22px;}'
   +   'html.ovw-lock,html.ovw-lock body{background:#0A0A0D !important;}'
   +   'html.ovw-lock body > *:not(#overdma-widget){visibility:hidden !important;}'
   +   'html.ovw-lock #overdma-widget{visibility:visible !important;}'
   + '}'
   + '@media(prefers-reduced-motion:reduce){.ovw-bub,.ovw-bub img,.ovw-bub::before,.ovw-bub::after,.ovw-tip,.ovw-modal,.ovw-modal-inner,.ovw-ping::after,.ovq-an-mascot,.ovq-an-glow::before{animation:none !important;}}';

  /* ---------- ICONOS SVG (inline, sin dependencias) ---------- */
  function ic(name, cls){
    var p = {
      circle:'<circle cx="12" cy="12" r="9"/>',
      check:'<circle cx="12" cy="12" r="9"/><path d="M9 12l2 2l4-4"/>',
      square:'<rect x="4" y="4" width="16" height="16" rx="3"/>',
      squareCheck:'<rect x="4" y="4" width="16" height="16" rx="3"/><path d="M9 12l2 2l4-4"/>',
      crosshair:'<circle cx="12" cy="12" r="8"/><path d="M12 2v4M12 18v4M2 12h4M18 12h4"/>',
      eye:'<path d="M2 12s3.5-7 10-7s10 7 10 7s-3.5 7-10 7s-10-7-10-7z"/><circle cx="12" cy="12" r="3"/>',
      layers:'<path d="M12 3l9 5l-9 5l-9-5z"/><path d="M3 13l9 5l9-5"/>',
      desktop:'<rect x="3" y="4" width="18" height="12" rx="1"/><path d="M8 20h8M12 16v4"/>',
      desktopHi:'<rect x="3" y="4" width="18" height="12" rx="1"/><path d="M8 20h8M12 16v4M7 11l2-2l2 2l3-4"/>',
      keyboard:'<rect x="2" y="6" width="20" height="12" rx="2"/><path d="M6 10h0M10 10h0M14 10h0M18 10h0M8 14h8"/>',
      gamepad:'<path d="M6 12h4M8 10v4"/><circle cx="15" cy="11" r="1"/><circle cx="17" cy="13" r="1"/><rect x="2" y="6" width="20" height="12" rx="4"/>',
      coin:'<circle cx="12" cy="12" r="8"/><path d="M12 8v8M9 10h4a2 2 0 0 1 0 4H9"/>',
      coins:'<circle cx="9" cy="9" r="6"/><path d="M15 15a6 6 0 1 0 0-12"/>',
      cash:'<rect x="2" y="6" width="20" height="12" rx="2"/><circle cx="12" cy="12" r="2"/>',
      diamond:'<path d="M6 3h12l3 6l-9 12L3 9z"/>',
      info:'<circle cx="12" cy="12" r="9"/><path d="M12 11v5M12 8h0"/>',
      tool:'<path d="M14 7a3 3 0 0 0-4 4l-6 6l2 2l6-6a3 3 0 0 0 4-4l-2 2l-2-2z"/>',
      mini:'<rect x="3" y="4" width="18" height="12" rx="1"/><path d="M8 20h8"/>',
      mail:'<rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3 7l9 6l9-6"/>',
      refresh:'<path d="M4 12a8 8 0 0 1 14-5M20 12a8 8 0 0 1-14 5"/><path d="M18 3v4h-4M6 21v-4h4"/>',
      discord:'<path d="M20.317 4.3698a19.7913 19.7913 0 0 0-4.8851-1.5152.0741.0741 0 0 0-.0785.0371c-.211.3753-.4447.8648-.6083 1.2495-1.8447-.2762-3.68-.2762-5.4868 0-.1636-.3933-.4058-.8742-.6177-1.2495a.077.077 0 0 0-.0785-.037 19.7363 19.7363 0 0 0-4.8852 1.515.0699.0699 0 0 0-.0321.0277C.5334 9.0458-.319 13.5799.0992 18.0578a.0824.0824 0 0 0 .0312.0561c2.0528 1.5076 4.0413 2.4228 5.9929 3.0294a.0777.0777 0 0 0 .0842-.0276c.4616-.6304.8731-1.2952 1.226-1.9942a.076.076 0 0 0-.0416-.1057c-.6528-.2476-1.2743-.5495-1.8722-.8923a.077.077 0 0 1-.0076-.1277c.1258-.0943.2517-.1923.3718-.2914a.0743.0743 0 0 1 .0776-.0105c3.9278 1.7933 8.18 1.7933 12.0614 0a.0739.0739 0 0 1 .0785.0095c.1202.099.246.1981.3728.2924a.077.077 0 0 1-.0066.1276 12.2986 12.2986 0 0 1-1.873.8914.0766.0766 0 0 0-.0407.1067c.3604.698.7719 1.3628 1.225 1.9932a.076.076 0 0 0 .0842.0286c1.961-.6067 3.9495-1.5219 6.0023-3.0294a.077.077 0 0 0 .0313-.0552c.5004-5.177-.8382-9.6739-3.5485-13.6604a.061.061 0 0 0-.0312-.0286zM8.02 15.3312c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9555-2.4189 2.157-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.9555 2.4189-2.1569 2.4189zm7.9748 0c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9554-2.4189 2.1569-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.9554 2.4189-2.1568 2.4189z"/>',
      cpu:'<rect x="6" y="6" width="12" height="12" rx="2"/><path d="M9 2v3M15 2v3M9 19v3M15 19v3M2 9h3M2 15h3M19 9h3M19 15h3"/>',
      card:'<rect x="2" y="5" width="20" height="14" rx="2"/><path d="M2 10h20"/>'
    };
    // El logo de Discord es relleno (fill), no de trazo como los demas iconos.
    if(name==='discord') return '<svg class="ovq-ico'+(cls?' '+cls:'')+'" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">'+p.discord+'</svg>';
    return '<svg class="ovq-ico'+(cls?' '+cls:'')+'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'+(p[name]||'')+'</svg>';
  }

  /* ---------- LOGICA DE RECOMENDACION ---------- */
  // Tipo de firmware segun juegos: EAC (cubre todo) o 'be' (V2.4: BattlEye/Ricochet/Javelin).
  function firmwareType(){
    var arr = Object.keys(S.games);
    if(arr.length===0) return null;
    return arr.some(function(g){ return EAC.indexOf(g)>=0 || OTROS.indexOf(g)>=0; }) ? 'eac' : 'be';
  }
  // Solo el nombre, para la etiqueta "Firmware: ..." del resultado.
  function firmwareReco(){
    var ty = firmwareType();
    if(!ty) return null;
    if(S.chosen==='dream') return {name: FW_PRIV_NAME, type:ty};
    if(proApplies()) return {name: FW_PRO_NAME, type:ty};
    return {name: FW_NAME[ty], type:ty};
  }
  /* Firmware PRO: solo camino BE, solo escritorio (su ficha no incluye la M2). */
  function proOffered(){
    return firmwareType()==='be' && S.pcType!=='laptop' && S.chosen!=='dream';
  }
  function proApplies(){ return S.fwPro && proOffered(); }
  // Variante de firmware SUELTO. Ambos firmwares son variante unica (ya no hay DNA-lock por tarjeta).
  function firmwareVariant(){
    var ty = firmwareType();
    if(!ty) return null;
    if(ty==='eac') return {n:FW_NAME.eac, p:P.fwEAC, vid:V.fwEAC};
    return {n:FW_NAME.be, p:P.fwBE, vid:V.fwBE};
  }
  function fuserItem(){
    if(S.monitorFuser==='dc505') return {n:DC5_NAME, p:P.fuserDC5, vid:V.fuserDC5};
    if(S.monitorFuser==='dc500') return {n:DC_NAME, p:P.fuserDC, vid:V.fuserDC};
    if(S.monitorFuser==='gl4k')  return {n:GL_NAME, p:P.fuserGL, vid:V.fuserGL};
    return {n:F10_NAME, p:P.fuser10, vid:V.fuser10};
  }
  function bundleFor(which){
    var ty = firmwareType();
    var items = [];

    // DREAM ⭐ (definido por Over): DC505 + DMA 100T + Firmware PRIVATE + Ferrum One,
    // + XIM MATRIX si juega con control. Se adapta a lo que pidio el cliente: el
    // fuser solo si quiere ESP; Ferrum (y XIM) solo si quiere aimbot.
    if(which==='dream'){
      var why = [];
      if(S.esp){ items.push({n:DC5_NAME, p:P.fuserDC5, vid:V.fuserDC5}); why.push(t('wDC5')); }
      items.push({n:'DMA 100T', p:P.card100, vid:V.card100}); why.push(t('w100'));
      items.push({n:FW_PRIV_NAME, p:P.fwPriv, vid:V.fwPriv}); why.push(t('wPriv'));
      if(S.aimbot){
        items.push({n:'Ferrum One', p:P.ferrum, vid:V.ferrum}); why.push(t('wFer'));
        if(S.periph==='ctrl') items.push({n:'XIM MATRIX', p:P.xim, vid:V.xim});
      }
      var totD = items.reduce(function(s,i){ return s+i.p; },0);
      return {items:items, total:totD, isBundle:false, saving:0, why:why,
              hasGL:false, hasDC:false, hasDC5:S.esp};
    }

    var laptop = (S.pcType==='laptop');
    var cardTier = (which==='cheap') ? '75' : '100';
    var tierLbl = (cardTier==='100'?'100T':'75T');
    var ftag = S.monitorFuser;
    var pro = proApplies();
    var cardP = (cardTier==='100'?P.card100:P.card75);
    var cardV = (cardTier==='100'?V.card100:V.card75);
    // Forma MAS BARATA de comprar la tarjeta con su firmware por separado: la
    // variante tarjeta+firmware (ya rebajada) o, con Pro, tarjeta sola + Pro.
    // Es la base honesta del "Ahorras $X" (antes se comparaba contra el camino
    // mas caro y 5 bundles decian ahorrar cuando costaban MAS que las piezas).
    var cardFwCheapest = ty ? (pro ? cardP + P.fwPro : CARD_FW[cardTier][ty].p) : cardP;

    // Bundles de la tienda (todos traen MAKCU): solo escritorio y ESP + Aimbot.
    // Si Shopify no deja vender la variante del bundle, se arma por piezas.
    if(!laptop && !!ty && S.esp && S.aimbot && ftag!=='dc505'){
      var BMAP  = (ftag==='dc500') ? BUNDLE4KPRO : (ftag==='gl4k') ? BUNDLE4K : BUNDLE;
      var bName = (ftag==='dc500') ? 'OverDMA 4K Pro Bundle' : (ftag==='gl4k') ? 'OverDMA 4K Bundle' : 'OverDMA Starter Bundle';
      var fName = (ftag==='dc500') ? DC_NAME : (ftag==='gl4k') ? GL_NAME : F10_NAME;
      var fP    = (ftag==='dc500') ? P.fuserDC : (ftag==='gl4k') ? P.fuserGL : P.fuser10;
      var bv = BMAP[cardTier][pro ? 'none' : ty];
      if(avail(bv.vid) && (!pro || avail(V.fwPro))){
        items.push({n:bName+' · '+tierLbl+' · '+(pro ? t('noFw') : (ty==='eac'?'EAC':'BE/COD')+' FW'),
                    p:bv.p, vid:bv.vid, bundle:true});
        if(pro) items.push({n:FW_PRO_NAME, p:P.fwPro, vid:V.fwPro});
        if(S.periph==='ctrl') items.push({n:'XIM MATRIX', p:P.xim, vid:V.xim});
        var tot = items.reduce(function(s,i){ return s+i.p; },0);
        var eq = cardFwCheapest + fP + P.makcu + (S.periph==='ctrl'?P.xim:0);
        var includes = ['DMA PCIe Card '+tierLbl, 'MAKCU', fName,
                        pro ? FW_PRO_NAME : FW_NAME[ty], t('incRemote')];
        return {items:items, total:tot, isBundle:true, saving:Math.max(0, eq-tot),
                includes:includes,
                cables:(ftag==='dc500'?'incCablesDC':(ftag==='gl4k'?'incCablesDP':'incCables')),
                hasGL:(ftag==='gl4k'), hasDC:(ftag==='dc500')};
      }
      // bundle no vendible -> sigue abajo, a la carta con las mismas piezas
    }

    // --- A la carta (laptop, solo-aimbot, solo-esp, o bundle no vendible) ---
    if(laptop){
      items.push({n:'DMA Card M2 · Thunderbolt', p:P.cardM2, vid:V.cardM2});
      var fwl = firmwareVariant();
      if(fwl) items.push({n:fwl.n, p:fwl.p, vid:fwl.vid});
    } else if(ty && pro){
      items.push({n:'DMA '+tierLbl, p:cardP, vid:cardV});
      items.push({n:FW_PRO_NAME, p:P.fwPro, vid:V.fwPro});
    } else if(ty){
      // Tarjeta + firmware en UNA variante: mas barato que por separado.
      var cf = CARD_FW[cardTier][ty];
      items.push({n:'DMA '+tierLbl+' + FW '+(ty==='eac'?'EAC':'BE/COD'), p:cf.p, vid:cf.vid});
    } else {
      items.push({n:'DMA '+tierLbl,
                  p:(cardTier==='100'?P.card100:P.card75),
                  vid:(cardTier==='100'?V.card100:V.card75)});
    }
    if(S.esp) items.push(fuserItem());
    if(S.aimbot){
      items.push({n:'MAKCU', p:P.makcu, vid:V.makcu});
      if(S.periph==='ctrl') items.push({n:'XIM MATRIX', p:P.xim, vid:V.xim});
    }
    var total = items.reduce(function(s,i){ return s+i.p; },0);
    return {items:items, total:total, isBundle:false, saving:0,
            hasGL:(S.esp && ftag==='gl4k'), hasDC:(S.esp && ftag==='dc500'), hasDC5:(S.esp && ftag==='dc505')};
  }
  function budgetMax(){
    switch(S.budget){
      case '<$300':     return 300;
      case '$300–$600': return 600;
      case '$600–$1000':return 1000;
      case '$1000+':    return Infinity;
      default:          return Infinity;
    }
  }
  function fitsBudget(total){ return total <= budgetMax(); }
  /* DREAM en TODOS los resultados de escritorio (Over, 2026-09-27): buena / mejor /
     DREAM. El DREAM ancla el precio (hace ver razonable la opcion ideal) y nunca se
     preselecciona: si se pasa del presupuesto lo dice ("Por encima de tu rango").
     Laptop no: la M2 es la unica tarjeta posible. */
  function dreamEligible(){
    return S.pcType!=='laptop' && (S.esp || S.aimbot) && !!firmwareType();
  }
  /* Preselecciona la mejor card que entre en el presupuesto (si el usuario no eligio a mano). */
  function autoChoose(){
    if(S.chosenManual) return;
    if(S.pcType==='laptop'){ S.chosen='ideal'; return; }
    var ideal = bundleFor('ideal'), cheap = bundleFor('cheap');
    if(fitsBudget(ideal.total)) S.chosen='ideal';
    else if(fitsBudget(cheap.total)) S.chosen='cheap';
    else S.chosen='cheap';
  }
  function orderTotal(){
    var base = bundleFor(S.chosen).total;
    return base + (S.addInstall?P.install:0);
  }
  /* Cuanto suma el Firmware PRO sobre la opcion elegida (se calcula, no se fija). */
  function proDelta(){
    var o = S.fwPro;
    S.fwPro = false; var a = bundleFor(S.chosen).total;
    S.fwPro = true;  var b = bundleFor(S.chosen).total;
    S.fwPro = o;
    return b - a;
  }
  function canAdvance(){
    if(S.step===1) return gamesCount()>0;
    if(S.step===2) return !!S.pcType;
    if(S.step===3) return S.aimbot||S.esp;
    // Monitor y periferico son OBLIGATORIOS cuando aplican (reportado por Over,
    // 2026-09-27): se podia dar "Siguiente" sin elegir, y el quiz asumia en
    // silencio el fuser mas barato y "mouse y teclado". Sin ESP / sin aimbot el
    // paso no aplica y el boton dice "Saltar".
    if(S.step===4) return !S.esp || !!S.monitorFuser;
    if(S.step===5) return !S.aimbot || !!S.periph;
    if(S.step===6) return !!S.budget;
    return true;
  }

  /* ---------- RENDER ---------- */
  var root, body, bar, stepLbl, backBtn, nextBtn, footEl, analyzeTimer=null, lastView=null, mbarIO=null, mbarHidden=false, cartReq=0;

  function buildShell(mount){
    mount.className = 'ovq-shell';
    mount.id = 'overdma-quiz-root';
    mount.innerHTML =
      '<div class="ovq-head">'
      +   '<div class="ovq-brand">'
      +     '<img class="ovq-logo" src="'+IMG_LOGO+'" alt="OverDMA" width="54" height="42" decoding="async"/>'
      +     '<div><div class="ovq-brand-txt">OVERDMA</div><div class="ovq-brand-sub">Bundle Builder</div></div>'
      +   '</div>'
      +   '<span class="ovq-steplbl" role="status" aria-live="polite"></span>'
      +   '<div class="ovq-head-r">'
      +     '<div class="ovq-lang"><button data-l="es" lang="es" aria-pressed="'+(S.lang==='es')+'"'+(S.lang==='es'?' class="on"':'')+'>ES</button><button data-l="en" lang="en" aria-pressed="'+(S.lang==='en')+'"'+(S.lang==='en'?' class="on"':'')+'>EN</button></div>'
      +   '</div>'
      + '</div>'
      + '<div class="ovq-barwrap"><div class="ovq-bar" style="width:20%"></div></div>'
      + '<div class="ovq-body"></div>'
      + '<div class="ovq-foot">'
      +   '<button class="ovq-btn ovq-back"></button>'
      +   '<div class="ovq-foot-r">'
      +     '<button class="ovq-next"></button>'
      +   '</div>'
      + '</div>';
    root = mount;
    root.setAttribute('lang', S.lang);
    body = mount.querySelector('.ovq-body');
    bar = mount.querySelector('.ovq-bar');
    stepLbl = mount.querySelector('.ovq-steplbl');
    backBtn = mount.querySelector('.ovq-back');
    nextBtn = mount.querySelector('.ovq-next');
    footEl = mount.querySelector('.ovq-foot');

    mount.querySelectorAll('.ovq-lang button').forEach(function(b){
      b.addEventListener('click', function(){ setLang(b.getAttribute('data-l')); });
    });
    backBtn.addEventListener('click', back);
    nextBtn.addEventListener('click', next);
  }

  function setLang(l){
    S.lang = l;
    root.setAttribute('lang', l);
    if(modalEl) modalEl.setAttribute('aria-label', t('dialogLbl'));
    root.querySelectorAll('.ovq-lang button').forEach(function(b){
      b.classList.toggle('on', b.getAttribute('data-l')===l);
      b.setAttribute('aria-pressed', String(b.getAttribute('data-l')===l));
    });
    render();
    syncLauncherText();
  }

  function render(){
    // Limpiar los botones extra del pie (solo el resultado los inyecta)
    footEl.querySelectorAll('.ovq-x,.ovq-hint').forEach(function(el){ el.remove(); });
    if(mbarIO){ mbarIO.disconnect(); mbarIO=null; }

    bar.style.width = Math.round(Math.min(S.step,6)/6*100)+'%';
    stepLbl.textContent = S.step<=6 ? (t('step')+' '+S.step+' '+t('of')+' 6') : t('result');
    backBtn.textContent = t('back');
    backBtn.style.visibility = S.step===1 ? 'hidden' : 'visible';

    nextBtn.style.display = S.step>6 ? 'none' : 'inline-block';
    if(S.step===4 && !S.esp) nextBtn.textContent = t('skip');
    else if(S.step===5 && !S.aimbot) nextBtn.textContent = t('skip');
    else if(S.step===6) nextBtn.textContent = t('seeBundle');
    else nextBtn.textContent = t('next');
    // Sin eleccion, Siguiente NO se desactiva del todo: se ve apagado y al tocarlo
    // explica que falta (antes parecia roto en el telefono). next() igual lo bloquea.
    var okNext = canAdvance();
    nextBtn.disabled = false;
    nextBtn.classList.toggle('off', !okNext);
    nextBtn.setAttribute('aria-disabled', okNext ? 'false' : 'true');

    // El pie se oculta durante la pantalla de analisis (es transitoria).
    footEl.style.display = (S.step>6 && S.phase==='analyzing') ? 'none' : '';
    footEl.classList.toggle('ovq-foot-res', S.step>6 && S.phase==='result');
    footEl.classList.toggle('ovq-first', S.step===1);

    if(S.step===1) renderGames();
    else if(S.step===2) renderPcType();
    else if(S.step===3) renderFeatures();
    else if(S.step===4) renderMonitor();
    else if(S.step===5) renderPeriph();
    else if(S.step===6) renderBudget();
    else { // step 7 = post-quiz
      if(S.phase==='analyzing') renderAnalyzing();
      else renderResult();
    }
    // Paso nuevo: el foco va al titulo (lectores de pantalla), sin mover el scroll.
    var view = S.step+'/'+S.phase;
    if(lastView!==null && lastView!==view){
      var h3 = body.querySelector('.ovq-h3');
      if(h3){ h3.setAttribute('tabindex','-1'); try{ h3.focus({preventScroll:true}); }catch(e){} }
    }
    lastView = view;
  }

  function hzText(x){ return T[S.lang][x] || x; }
  function head(h3,sub){ return '<h3 class="ovq-h3">'+h3+'</h3><p class="ovq-sub">'+sub+'</p>'; }

  function renderGames(){
    var h = head(t('q1'), t('q1s'));
    GAMES.forEach(function(g){
      h += '<div class="ovq-grouplbl">'+t(g.key)+'</div><div class="ovq-grid">';
      g.items.forEach(function(it){
        var on = !!S.games[it];
        h += '<button class="ovq-opt'+(on?' on':'')+'" data-game="'+enc(it)+'">'+ic(on?'check':'circle')+'<span>'+it+'</span></button>';
      });
      h += '</div>';
    });
    h += '<button class="ovq-btn ovq-nogame" style="margin-top:16px;width:100%;color:#8B92F5;border-color:#3a3f6e;">'
       + '<img class="ovq-dico" src="'+IMG_DISCORD+'" alt="" width="18" height="18" decoding="async"/> '+t('noGame')+'</button>';
    body.innerHTML = h;
    body.querySelectorAll('[data-game]').forEach(function(b){
      b.addEventListener('click', function(){ toggleGame(dec(b.getAttribute('data-game'))); });
    });
    body.querySelector('.ovq-nogame').addEventListener('click', goDiscord);
  }

  function renderPcType(){
    var h = head(t('qPc'), t('qPcS'));
    var opts = [['desktop',t('deskOpt'),t('deskOptS'),'desktop'],['laptop',t('lapOpt'),t('lapOptS'),'mini']];
    h += '<div class="ovq-stack">';
    opts.forEach(function(o){
      var on = S.pcType===o[0];
      h += '<button class="ovq-opt big'+(on?' on':'')+'" data-pc="'+o[0]+'">'+ic(on?'check':'circle')+ic(o[3],'big')+'<span>'+o[1]+'<span class="ovq-optsub">'+o[2]+'</span></span></button>';
    });
    h += '</div>';
    // Alerta de compatibilidad (de la descripcion del producto DMA Card M2)
    if(S.pcType==='laptop'){
      h += '<div class="ovq-note" style="margin-top:14px;">'+ic('info','big')+'<span>'+t('m2Note')+'</span></div>';
    }
    body.innerHTML = h;
    body.querySelectorAll('[data-pc]').forEach(function(b){
      b.addEventListener('click', function(){ S.pcType=b.getAttribute('data-pc'); render(); });
    });
  }

  function renderFeatures(){
    var sel = (S.aimbot&&S.esp)?'both':(S.aimbot?'aim':(S.esp?'esp':null));
    var opts = [['aim',t('aimOnly'),t('aimOnlyS'),'crosshair'],['esp',t('espOnly'),t('espOnlyS'),'eye'],['both',t('both'),t('bothS'),'layers']];
    var h = head(t('q2'), t('q2s')) + '<div class="ovq-stack">';
    opts.forEach(function(o){
      var on = sel===o[0];
      h += '<button class="ovq-opt big'+(on?' on':'')+'" data-feat="'+o[0]+'">'+ic(on?'check':'circle')+ic(o[3],'big')+'<span>'+o[1]+'<span class="ovq-optsub">'+o[2]+'</span></span></button>';
    });
    body.innerHTML = h+'</div>';
    body.querySelectorAll('[data-feat]').forEach(function(b){
      b.addEventListener('click', function(){ setFeat(b.getAttribute('data-feat')); });
    });
  }

  function renderMonitor(){
    var h = head(t('q3'), t('q3s'));
    if(!S.esp){
      h += '<div class="ovq-note">'+ic('info','big')+'<span>'+t('noEsp')+'</span></div>';
      body.innerHTML = h; return;
    }
    // La pregunta es sobre SU monitor: sin nombres de fuser (Over, 2026-09-27).
    // El fuser y sus avisos aparecen en el resultado.
    h += '<div class="ovq-grouplbl">'+t('resLbl')+'</div><div class="ovq-mgrid">';
    MON_ORDER.forEach(function(k){
      var r = MON[k], on = S.monRes===k;
      h += '<button class="ovq-opt big'+(on?' on':'')+'" data-res="'+k+'">'+ic(k==='1080'||k==='1440'?'desktop':'desktopHi','big')
         + '<span>'+r.lbl+'<span class="ovq-optsub">'+r.sub+'</span></span></button>';
    });
    h += '</div>';
    if(S.monRes){
      h += '<div class="ovq-grouplbl ovq-hzlbl">'+t('hzLbl')+'</div><div class="ovq-mgrid">';
      MON[S.monRes].hz.concat([['nz','hzUnknown','hdmi']]).forEach(function(z){
        var on = S.monHz===z[0];
        h += '<button class="ovq-opt'+(on?' on':'')+'" data-hz="'+z[0]+'" data-fuser="'+z[2]+'">'+ic(on?'check':'circle')
           + '<span>'+hzText(z[1])+'</span></button>';
      });
      h += '</div><p class="ovq-sub" style="margin:12px 0 0;">'+t('hzHelp')+'</p>';
    }
    body.innerHTML = h;
    body.querySelectorAll('[data-res]').forEach(function(b){
      b.addEventListener('click', function(){
        var k = b.getAttribute('data-res');
        var changed = (S.monRes!==k);
        if(changed){ S.monRes=k; S.monHz=null; S.monitorFuser=null; S.monitor=null; }
        render();
        // En el telefono los Hz aparecen debajo, fuera de la vista: se lleva al cliente ahi.
        if(changed) revealHz();
      });
    });
    body.querySelectorAll('[data-hz]').forEach(function(b){
      b.addEventListener('click', function(){
        S.monHz = b.getAttribute('data-hz');
        S.monitorFuser = b.getAttribute('data-fuser');
        var z = MON[S.monRes].hz.concat([['nz','hzUnknown','hdmi']]).filter(function(x){ return x[0]===S.monHz; })[0];
        S.monitor = MON[S.monRes].lbl+' · '+hzText(z[1]);
        render();
      });
    });
  }

  function renderPeriph(){
    var h = head(t('q4'), t('q4s'));
    if(!S.aimbot){
      h += '<div class="ovq-note">'+ic('info','big')+'<span>'+t('noAim')+'</span></div>';
      body.innerHTML = h; return;
    }
    var opts = [['km',t('km'),t('kmS'),'keyboard'],['ctrl',t('ctrl'),t('ctrlS'),'gamepad']];
    h += '<div class="ovq-stack">';
    opts.forEach(function(o){
      var on = S.periph===o[0];
      h += '<button class="ovq-opt big'+(on?' on':'')+'" data-per="'+o[0]+'">'+ic(on?'check':'circle')+ic(o[3],'big')+'<span>'+o[1]+'<span class="ovq-optsub">'+o[2]+'</span></span></button>';
    });
    body.innerHTML = h+'</div>';
    body.querySelectorAll('[data-per]').forEach(function(b){
      b.addEventListener('click', function(){ S.periph=b.getAttribute('data-per'); render(); });
    });
  }

  function renderBudget(){
    var opts = [['<$300','coin'],['$300–$600','coins'],['$600–$1000','cash'],['$1000+','diamond']];
    var h = head(t('q5'), t('q5s')) + '<div class="ovq-bgrid">';
    opts.forEach(function(o){
      var on = S.budget===o[0];
      h += '<button class="ovq-opt budget'+(on?' on':'')+'" data-bud="'+enc(o[0])+'">'+ic(o[1],'big')+o[0]+'</button>';
    });
    body.innerHTML = h+'</div>';
    body.querySelectorAll('[data-bud]').forEach(function(b){
      b.addEventListener('click', function(){ S.budget=dec(b.getAttribute('data-bud')); S.chosenManual=false; render(); });
    });
  }

  /* ---------- PANTALLA "ANALIZANDO" ---------- */
  function renderAnalyzing(){
    body.innerHTML =
      '<div class="ovq-an">'
      + '<div class="ovq-an-glow"><img class="ovq-an-mascot" src="'+IMG_MASCOT+'" alt="Over"/></div>'
      + '<div class="ovq-an-t">'+t('anTitle')+'</div>'
      + '<div class="ovq-an-msg"></div>'
      + '<div class="ovq-an-track"><div class="ovq-an-bar"></div></div>'
      + '</div>';
    runAnalyze();
  }
  function runAnalyze(){
    if(analyzeTimer){ clearTimeout(analyzeTimer); analyzeTimer=null; }
    var msgs = t('anSteps');
    var i = 0;
    var msgEl = body.querySelector('.ovq-an-msg');
    var barEl = body.querySelector('.ovq-an-bar');
    function tick(){
      if(!msgEl || !msgEl.isConnected) return; // modal cerrado / re-render
      msgEl.textContent = msgs[i];
      if(barEl) barEl.style.width = Math.round((i+1)/msgs.length*100)+'%';
      i++;
      if(i<msgs.length) analyzeTimer = setTimeout(tick, 620);
      else analyzeTimer = setTimeout(finish, 650);
    }
    function finish(){
      analyzeTimer=null;
      autoChoose();
      S.phase = 'result';
      render();
      scrollQuizTop();
    }
    tick();
  }

  /* Resumen del build: se usa en la nota del carrito
     (llega en la orden -> soporte ve el setup del cliente) y el boton Copiar. */
  function buildSummary(){
    var data = bundleFor(S.chosen);
    var L = [];
    L.push('=== OverDMA Bundle Builder ===');
    L.push('Juegos/Games: '+(Object.keys(S.games).join(', ')||'-'));
    L.push('PC: '+(S.pcType==='laptop'?'Laptop (DMA M2 · Thunderbolt 4)':'Desktop/Escritorio'));
    var feats = (S.aimbot?'Aimbot':'')+(S.aimbot&&S.esp?' + ':'')+(S.esp?'ESP':'');
    L.push('Funciones/Features: '+(feats||'-'));
    if(S.esp)    L.push('Monitor: '+(S.monitor||'-'));
    if(S.aimbot) L.push('Periferico/Peripheral: '+(S.periph==='ctrl'?'Control (+XIM)':'Mouse & Keyboard'));
    L.push('Presupuesto/Budget: '+(S.budget||'-'));
    L.push('Opcion/Option: '+(S.chosen==='dream'?'DREAM ('+bundleFor('dream').items.map(function(i){ return i.n; }).join(' + ')+')'
          : S.pcType==='laptop'?'Laptop (DMA M2)'
          : S.chosen==='cheap'?'Economico (75T)':'Recomendado (100T)'));
    L.push('--- Build ---');
    data.items.forEach(function(i){ L.push('- '+i.n+'  '+money(i.p)); });
    if(S.addInstall) L.push('- DMA Installation Service  '+money(P.install));
    L.push('TOTAL: '+money(orderTotal()));
    return L.join('\n');
  }
  function leadSource(){
    var src = '';
    try{ src = new URLSearchParams(location.search).get('utm_source') || ''; }catch(e){}
    return (src||'web') + ' · ' + location.pathname;
  }
  /* ---------- RESULTADO ---------- */
  function note(txt, cls){
    return '<div class="ovq-note'+(cls?' '+cls:'')+'" style="margin-top:12px;">'+ic('info','big')+'<span>'+txt+'</span></div>';
  }
  function pcard(key, title, tag, data, accent){
    var on = S.chosen===key;
    var lines = data.items.map(function(i){
      var so = avail(i.vid) ? '' : ' <span class="ovq-sold">'+t('soldTag')+'</span>';
      return '<div class="ovq-line"><span>'+i.n+so+'</span><span>'+money(i.p)+'</span></div>';
    }).join('');
    var fit = fitsBudget(data.total)
      ? '<span class="ovq-fit ok">'+t('fitOk')+'</span>'
      : '<span class="ovq-fit over">'+t('fitOver')+'</span>';
    var save = (data.isBundle && data.saving>0)
      ? '<div class="ovq-save">'+t('saveL')+' '+money(data.saving)+' '+t('saveR')+'</div>'
      : '';
    // Checklist de lo incluido en el bundle (estilo "que trae la caja")
    var incs = '';
    if(data.isBundle && data.includes){
      incs = '<div class="ovq-inct">'+t('incTitle')+'</div><div class="ovq-incs">';
      data.includes.concat([t(data.cables||'incCables'), t('incSupport')]).forEach(function(x){
        incs += '<span class="ovq-inc"><span class="ck" aria-hidden="true">✓</span>'+x+'</span>';
      });
      incs += '</div>';
    }
    var dream = (key==='dream');
    var why = '';
    if(dream && data.why && data.why.length){
      why = '<div class="ovq-inct">'+t('whyTitle')+'</div><div class="ovq-why">';
      data.why.forEach(function(x){ why += '<div class="ovq-why-i"><span class="st" aria-hidden="true">✦</span><span>'+x+'</span></div>'; });
      why += '</div>';
    }
    // Avisos de la opcion ELEGIDA dentro de su tarjeta (en el telefono quedaban debajo
    // de la DREAM, lejos de la tarjeta a la que se refieren). En escritorio se ven abajo.
    var cnotes = on ? ((data.hasGL ? note(t('dpNote'),'ovq-note-sel') : '')
                    + (data.hasDC ? note(t('dcNote'),'ovq-note-sel') : '')
                    + (data.hasDC5 ? note(t('dc5Note'),'ovq-note-sel') : '')) : '';
    return '<div class="ovq-pcard'+(on?' on':'')+(dream?' dream':'')+'" data-card="'+key+'" role="radio" tabindex="0" aria-checked="'+(on?'true':'false')+'">'
      + (dream ? '<div class="ovq-dream-rib">★ '+t('dreamRib')+'</div>' : '')
      + '<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:10px;">'
      +   '<span class="ovq-tag'+(accent?' acc':'')+'">'+tag+'</span>'+ic(on?'check':'circle')
      + '</div>'
      + '<h4 class="ovq-ctitle">'+title+'</h4>'
      + lines
      + incs
      + why
      + '<div class="ovq-ptot"><span>'+t('total')+'</span><span>'+money(data.total)+'</span></div>'
      + save
      + fit
      + cnotes
      + '</div>';
  }
  function addon(key, title, desc, price, active, quiet){
    return '<div class="ovq-addon'+(active?' on':'')+(quiet?' quiet':'')+'" data-addon="'+key+'" role="checkbox" tabindex="0" aria-checked="'+(active?'true':'false')+'">'
      + '<div class="ovq-addon-row"><div class="ovq-addon-l">'+ic(active?'squareCheck':'square','big')
      + '<div><div class="ovq-addon-t">'+title+' <span class="ovq-addon-opt">('+t('optional')+')</span>'
   /* el badge se queda (oculto) al marcarlo: la tarjeta ya no encoge bajo el dedo */
      + (quiet ? '' : '<span class="ovq-addon-badge'+(active?' off':'')+'">'+t('popBadge')+'</span>')+'</div>'
      + '<div class="ovq-addon-desc">'+desc+'</div></div></div>'
      + '<div class="ovq-addon-price">+'+money(price)+'</div></div></div>';
  }

  function renderResult(){
    var fw = firmwareReco();
    var laptop = (S.pcType==='laptop');
    if(laptop && S.chosen==='cheap') S.chosen='ideal';
    if(S.chosen==='dream' && !dreamEligible()) S.chosen='ideal';
    var cheap = bundleFor('cheap'), ideal = bundleFor('ideal');
    var dream = dreamEligible() ? bundleFor('dream') : null;
    var chosenData = bundleFor(S.chosen);
    // Algo que Shopify no deja vender -> no mandar al carrito (fallaria): Discord.
    var blocked = chosenData.items.some(function(i){ return !avail(i.vid); })
               || (S.addInstall && !avail(V.install));
    var pickLbl = S.chosen==='dream' ? '★ '+t('dreamRib') : laptop ? t('laptopTag') : S.chosen==='cheap' ? t('economic') : t('recommended');
    var ctaTxt = S.adding ? t('adding') : (blocked ? t('reserveCta') : t('addCart'));
    var h = '';

    // Mensaje personalizado: nombra los juegos que eligio el cliente.
    var games = Object.keys(S.games);
    var gtxt = games.slice(0,2).join(', ') + (games.length>2 ? ' +'+(games.length-2)+' '+t('more') : '');
    h += '<div class="ovq-res-head">'
      + '<img class="ovq-mascot" src="'+IMG_MASCOT+'" alt="Over" width="64" height="64" decoding="async"/>'
      + '<div><h3 class="ovq-h3" style="margin-bottom:2px;">'+t('resTitle')+'</h3>'
      + '<p class="ovq-sub" style="margin:0;">'
      + (fw
          ? t('mascotMsg1')+' — <span style="color:#fff;font-weight:600;">'+enc(gtxt)+'</span> — '+t('mascotMsg2')+' '
            + t('fwLabel')+': <span style="color:var(--g);">'+fw.name+'</span>'
          : '<span style="color:#E24B4A;">'+t('pickGame')+'</span>')
      + '</p></div></div>';

    if(fw){
      // Dos columnas: izquierda las tarjetas y alertas; derecha el resumen STICKY
      // con add-on, total, carrito y financiamiento SIEMPRE a la vista.
      h += '<div class="ovq-res-cols">'
         +   '<div class="ovq-res-main">'
         +     (laptop
                 ? '<div class="ovq-cards" role="radiogroup">'+pcard('ideal', t('laptopCard'), t('laptopTag'), ideal, true)+'</div>'
                 : dream
                   // Separacion recomendados | DREAM (Over, 2026-09-27)
                   ? '<div class="ovq-cards tiers" role="radiogroup">'
                     + '<div class="ovq-grp ovq-grp-rec"><div class="ovq-grp-t">'+t('recGrp')+'</div><div class="ovq-grp-cards">'
                     +   pcard('cheap', t('budgetCard'), t('economic'), cheap, false)
                     +   pcard('ideal', t('idealCard'), t('recommended'), ideal, true)
                     + '</div></div>'
                     + '<div class="ovq-sep" aria-hidden="true"><span>'+t('orSep')+'</span></div>'
                     + '<div class="ovq-grp ovq-grp-dream"><div class="ovq-grp-t dr">★ '+t('dreamGrp')+'</div><div class="ovq-grp-cards">'
                     +   pcard('dream', t('dreamCard'), t('dreamTag'), dream, true)
                     + '</div></div></div>'
                   : '<div class="ovq-cards" role="radiogroup">'+pcard('cheap', t('budgetCard'), t('economic'), cheap, false)
                     + pcard('ideal', t('idealCard'), t('recommended'), ideal, true)+'</div>')
         +     (blocked ? note(t('oosNote')) : '')
         +     ((S.esp && S.monHz==='nz' && S.chosen!=='dream') ? note(t('noHzNote')) : '')
         +     (chosenData.hasGL ? note(t('dpNote'),'ovq-note-sel') : '')
         +     (chosenData.hasDC ? note(t('dcNote'),'ovq-note-sel') : '')
         +     (chosenData.hasDC5 ? note(t('dc5Note'),'ovq-note-sel') : '')
         +     (laptop ? note(t('m2Note')) : '')
         +   '</div>'
         +   '<aside class="ovq-res-side"><div class="ovq-sum">'
         +     '<div class="ovq-pick"><span>'+t('yourPick')+'</span><b>'+pickLbl+'</b><span class="p">'+money(chosenData.total)+'</span></div>'
         +     '<div class="ovq-grouplbl">'+t('addOns')+'</div>'
         +     addon('install',t('installTitle'),t('installDesc'),P.install,S.addInstall)
         +     (proOffered() ? addon('fwpro',t('proTitle'),t('proDesc'),proDelta(),S.fwPro,true) : '')
         +     '<div class="ovq-ordertot"><span class="l">'+t('orderTotal')+'</span><span class="v">'+money(orderTotal())+'</span></div>'
         +     '<button class="ovq-cta"'+(S.adding?' disabled':'')+'>'+ctaTxt+'</button>'
         +     (S.cartSlow ? '<p class="ovq-err ovq-slow" role="status">'+t('cartSlow')+' <a href="'+cartRoot()+'cart">'+t('viewCart')+'</a></p>' : '')
         +     (S.cartError ? '<p class="ovq-err" role="alert">'+t(S.cartError)+'</p>' : '')
         +     (blocked ? '' : '<p class="ovq-fin"><img src="'+IMG_CARD+'" alt="" width="20" height="20" decoding="async"/> '+t('financing')+'</p>')
         +   '</div></aside>'
         + '</div>'
   /* barra fija del telefono: lo elegido + total + boton. Se esconde cuando el boton real se ve. */
         + '<div class="ovq-mbar-w"><div class="ovq-mbar'+(mbarHidden?' hide':'')+'"><div class="ovq-mbar-t"><small>'+pickLbl+'</small><b>'+money(orderTotal())+'</b></div>'
         +   '<button class="ovq-mcta"'+(S.adding?' disabled':'')+'>'+ctaTxt+'</button></div></div>';
    }
    body.innerHTML = h;

    /* Acciones del resultado: van ABAJO, en el pie del widget.
       "Hablar con nosotros" es el unico boton de Discord. */
    var fr = footEl.querySelector('.ovq-foot-r');
    function footBtn(cls, html, fn){
      var b = document.createElement('button');
      b.className = 'ovq-btn ovq-x '+cls;
      b.innerHTML = html;
      b.addEventListener('click', fn);
      fr.insertBefore(b, nextBtn);
      return b;
    }
    footBtn('ovq-redo', t('redo'), reset);
    if(fw){
      var copyBtn = footBtn('ovq-copy', t('copyBuild'), function(){
        // Solo dice 'Copiado' si de verdad se copio (antes lo decia aunque fallara)
        copyText(buildSummary()).then(function(ok){
          var col = ok ? 'var(--ok)' : '#FF8A80';
          copyBtn.textContent = ok ? t('copied') : t('copyFail');
          copyBtn.style.borderColor = col; copyBtn.style.color = col;
          setTimeout(function(){ if(copyBtn.isConnected){ copyBtn.textContent=t('copyBuild'); copyBtn.style.borderColor=''; copyBtn.style.color=''; } }, 2200);
        });
      });
    }
    footBtn('ovq-talk', t('talk'), goDiscord);

    function keyActivate(el){
      el.addEventListener('keydown', function(e){ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); el.click(); } });
    }
    function refocus(sel){ var n = body.querySelector(sel); if(n){ try{ n.focus({preventScroll:true}); }catch(e){} } }
    body.querySelectorAll('[data-card]').forEach(function(c){
      keyActivate(c);
      c.addEventListener('click', function(){
        if(S.adding) return;
        var k = c.getAttribute('data-card'), had = (document.activeElement===c);
        S.chosen=k; S.chosenManual=true; S.cartError=null; render();
        if(had) refocus('[data-card="'+k+'"]');
      });
    });
    body.querySelectorAll('[data-addon]').forEach(function(a){
      keyActivate(a);
      a.addEventListener('click', function(){
        if(S.adding) return;
        var k = a.getAttribute('data-addon'), had = (document.activeElement===a);
        if(k==='fwpro') S.fwPro=!S.fwPro;
        else S.addInstall=!S.addInstall;
        S.cartError=null; render();
        if(had) refocus('[data-addon="'+k+'"]');
      });
    });
    body.querySelectorAll('.ovq-cta,.ovq-mcta').forEach(function(c){
      c.addEventListener('click', blocked ? goDiscord : addToCart);
    });
    // La barra fija se esconde cuando el boton del panel ya esta a la vista.
    var mb = body.querySelector('.ovq-mbar'), sumCta = body.querySelector('.ovq-cta');
    if(mb && sumCta && 'IntersectionObserver' in window){
      // Estado real YA (sin esperar al observer): si difiere del anterior se corrige sin animacion.
      var cb = sumCta.getBoundingClientRect(), seen = cb.bottom > 0 && cb.top < window.innerHeight;
      if(seen !== mbarHidden){ mb.style.transition='none'; mb.classList.toggle('hide', seen); void mb.offsetWidth; mb.style.transition=''; mbarHidden = seen; }
      mbarIO = new IntersectionObserver(function(es){ es.forEach(function(e){ mbarHidden = e.isIntersecting; mb.classList.toggle('hide', mbarHidden); }); });
      mbarIO.observe(sumCta);
    }
    var vc = body.querySelector('.ovq-slow a');
    if(vc) vc.addEventListener('click', function(e){ e.preventDefault(); window.location.href = vc.href; });
  }

  /* ---------- CARRITO SHOPIFY (/cart/add) ----------
     - Un solo envio: con doble toque se mandaban 2 POST (el boton se re-habilitaba
       si syncLive re-pintaba el resultado a mitad de la carga).
     - Si Shopify rechaza (422: agotado, limite...) se explica y se puede reintentar;
       antes caia al permalink /cart/{id}:{qty}, que va directo al checkout y
       reemplaza el carrito sin la nota del build.
     - Red lenta: a los 12s NO se aborta ni se ofrece reintentar. El POST pudo llegar
       a Shopify aunque la respuesta tarde, y un segundo envio duplicaria el bundle
       en el carrito (lo encontro la revision de v5). Se avisa y se ofrece abrir el
       carrito; si la respuesta llega, se sigue solo.
     - La nota del build es opcional: si /cart/update.js tarda mas de 4s se sigue sin ella.
     - Cada intento lleva un numero: si el cliente vuelve atras o rehace el quiz,
       la respuesta vieja ya no toca la pantalla nueva.
     - Rutas con el prefijo de mercado/idioma de Shopify (/en-us/cart...). */
  function cartRoot(){
    try{ var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root; if(r) return r; }catch(e){}
    return '/';
  }
  function addToCart(){
    if(S.adding) return;
    var data = bundleFor(S.chosen);
    var byId = {};
    data.items.forEach(function(i){ byId[i.vid] = (byId[i.vid]||0)+1; });
    if(S.addInstall) byId[V.install] = (byId[V.install]||0)+1;

    var payload = { items: Object.keys(byId).map(function(id){ return {id:parseInt(id,10), quantity:byId[id]}; }) };

    var req = ++cartReq;
    S.adding = true; S.cartError = null; S.cartSlow = false;
    body.querySelectorAll('.ovq-cta,.ovq-mcta').forEach(function(c){ c.disabled=true; c.textContent=t('adding'); });
    body.querySelectorAll('.ovq-err').forEach(function(e){ e.remove(); });

    var base = cartRoot();
    function alive(){ return req === cartReq; }
    function onResult(){ return root && S.step>6 && S.phase==='result'; }
    var slowT = setTimeout(function(){
      if(!alive()) return;
      S.cartSlow = true;
      if(onResult()) render();
    }, 12000);
    function fail(key){
      clearTimeout(slowT);
      if(!alive()) return;
      S.adding = false; S.cartSlow = false; S.cartError = key;
      if(onResult()) render();
    }
    fetch(base+'cart/add.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify(payload)
    }).then(function(r){
      if(!r.ok){
        return r.json().catch(function(){ return {}; }).then(function(j){
          var e = new Error('cart'); e.http = r.status; e.detail = (j && (j.description || j.message)) || ''; throw e;
        });
      }
      // Adjunta el build como nota del carrito: llega en la orden y soporte
      // ve el setup exacto del cliente. Si falla o tarda, la compra sigue igual.
      return Promise.race([
        fetch(base+'cart/update.js', {
          method:'POST',
          headers:{'Content-Type':'application/json'},
          body:JSON.stringify({note: buildSummary() + '\nOrigen/Source: ' + leadSource()})
        }).catch(function(){}),
        new Promise(function(res){ setTimeout(res, 4000); })
      ]);
    }).then(function(){
      clearTimeout(slowT);
      if(!alive()) return;
      window.location.href = base+'cart';
    }).catch(function(err){
      if(err && err.http){
        try{ console.warn('[OverDMA quiz] /cart/add.js', err.http, err.detail); }catch(e){}
        fail('cartErr'); return;
      }
      clearTimeout(slowT);
      if(!alive()) return;
      // Red caida (TypeError): permalink directo /cart/{variant}:{qty},...
      var parts = Object.keys(byId).map(function(id){ return id+':'+byId[id]; });
      window.location.href = base+'cart/'+parts.join(',');
    });
  }

  /* ---------- HELPERS ---------- */
  // Devuelve una promesa con true/false segun si de verdad se copio.
  function copyText(s){
    function legacy(){
      // Dentro del quiz (no en <body>: con el modal abierto el resto de la pagina
      // esta oculta y no se podria seleccionar). 16px: iOS no hace zoom.
      var ta=document.createElement('textarea'); ta.value=s; ta.setAttribute('readonly','');
      ta.style.cssText='position:fixed;top:0;left:0;width:1px;height:1px;opacity:0;font-size:16px;';
      var host = root || document.body; host.appendChild(ta);
      var ok=false;
      try{ ta.focus(); ta.select(); ta.setSelectionRange(0, s.length); ok=document.execCommand('copy'); }catch(e){}
      host.removeChild(ta);
      return ok;
    }
    if(navigator.clipboard && navigator.clipboard.writeText){
      return navigator.clipboard.writeText(s).then(function(){ return true; }, function(){ return legacy(); });
    }
    return Promise.resolve(legacy());
  }
  function enc(s){ s=s||''; return String(s).replace(/&/g,'&amp;').replace(/"/g,'&quot;'); }
  function dec(s){ return String(s).replace(/&quot;/g,'"').replace(/&amp;/g,'&'); }
  function toggleGame(g){ if(S.games[g]) delete S.games[g]; else S.games[g]=true; render(); }
  function setFeat(f){
    S.aimbot = (f==='aim'||f==='both');
    S.esp = (f==='esp'||f==='both');
    if(!S.esp){ S.monitor=null; S.monitorFuser=null; S.monRes=null; S.monHz=null; }
    if(!S.aimbot) S.periph=null;
    render();
  }
  function stepHint(){
    if(S.step===1) return t('pickGame');
    if(S.step===2) return t('pickPc');
    if(S.step===3) return t('pickFeat');
    if(S.step===4) return S.monRes ? t('pickHz') : t('pickRes');
    if(S.step===5) return t('pickPer');
    return t('pickBud');
  }
  function showHint(){
    var h = footEl.querySelector('.ovq-hint');
    if(!h){ h = document.createElement('div'); h.className='ovq-hint'; h.setAttribute('role','alert'); footEl.insertBefore(h, footEl.firstChild); }
    h.textContent = stepHint();
    nextBtn.classList.remove('nudge'); void nextBtn.offsetWidth; nextBtn.classList.add('nudge');
  }
  function next(){
    if(!canAdvance()){ showHint(); return; }
    if(S.step<6){ S.step++; render(); scrollQuizTop(); }
    else if(S.step===6){ S.step=7; S.phase='analyzing'; render(); scrollQuizTop(); } // dispara el analisis
  }
  function back(){
    if(S.step>6){ // volver del post-quiz a la ultima pregunta
      if(analyzeTimer){ clearTimeout(analyzeTimer); analyzeTimer=null; }
      cartReq++; S.adding=false; S.cartSlow=false; S.cartError=null;
      S.step=6; S.phase=null; render(); scrollQuizTop(); return;
    }
    if(S.step>1){ S.step--; render(); scrollQuizTop(); }
  }
  function reset(){
    if(analyzeTimer){ clearTimeout(analyzeTimer); analyzeTimer=null; }
    S.step=1; S.games={}; S.pcType=null; S.aimbot=false; S.esp=false; S.monitor=null; S.monitorFuser=null;
    S.monRes=null; S.monHz=null; S.periph=null; S.budget=null; S.addInstall=false; S.fwPro=false;
    S.chosen='ideal'; S.chosenManual=false; S.phase=null;
    cartReq++; S.adding=false; S.cartError=null; S.cartSlow=false; mbarHidden=false;
    render();
    scrollQuizTop();
  }
  function goDiscord(){
    var url = 'https://discord.com/invite/overdma';
    var w = window.open(url, '_blank');
    if(w){ try{ w.opener = null; }catch(e){} }
    else { window.location.href = url; } // bloqueador de ventanas: ir en la misma pestana
  }
  /* Al cambiar de paso el cliente debe ver el INICIO del quiz. Antes no se movia el
     scroll: en el telefono aterrizaba a media pantalla del paso siguiente, o en el pie
     de la tienda (pagina inline). En el modal el que hace scroll es .ovw-modal-inner. */
  function headerOffset(){
    var off = 0;
    try{
      var els = document.querySelectorAll('sticky-header,.shopify-section-header-sticky,header');
      for(var i=0;i<els.length;i++){
        var p = getComputedStyle(els[i]).position;
        if(p==='fixed' || p==='sticky'){ var hh = els[i].getBoundingClientRect().height; if(hh>off && hh<window.innerHeight/2) off = hh; }
      }
    }catch(e){}
    return off;
  }
  function scrollQuizTop(){
    if(!root) return;
    var sc = root.closest ? root.closest('.ovw-modal-inner') : null;
    if(sc){ sc.scrollTop = 0; return; }
    var top = root.getBoundingClientRect().top, off = headerOffset();
    if(top < off || top > window.innerHeight*0.5){
      var y = top + (window.pageYOffset || document.documentElement.scrollTop || 0) - off - 8;
      window.scrollTo(0, Math.max(0, y));
    }
  }
  function revealHz(){
    var lbl = body.querySelector('.ovq-hzlbl'), grid = lbl && lbl.nextElementSibling;
    if(!grid) return;
    var foot = footEl.getBoundingClientRect();
    var limit = Math.min(window.innerHeight, foot.top > 0 ? foot.top : window.innerHeight);
    if(grid.getBoundingClientRect().bottom > limit){
      try{ lbl.scrollIntoView({block:'start', behavior:'smooth'}); }catch(e){ lbl.scrollIntoView(); }
    }
  }

  /* ---------- WIDGET FLOTANTE: launcher, globito y modal ---------- */
  var widget, launcherEl, tipEl, modalEl, built=false, tipTimer, escBound=null;
  var lockY=0, lockFixed=false, lastFocus=null, inertEls=[], downOnOverlay=false, histPushed=false;
  var inlineHost=null, cssInjected=false;

  function injectCSS(){
    if(cssInjected) return;
    cssInjected = true;
    var st = document.createElement('style'); st.textContent = CSS; document.head.appendChild(st);
  }

  function buildLauncher(){
    widget = document.getElementById('overdma-widget');
    if(!widget){ widget = document.createElement('div'); widget.id='overdma-widget'; document.body.appendChild(widget); }
    injectCSS();

    widget.innerHTML =
      '<div class="ovw-launch">'
      + '<button class="ovw-bub" aria-label="'+t('launcherAria')+'">'
      +   '<img src="'+IMG_MASCOT+'" alt="Over" width="66" height="66" decoding="async"/><span class="ovw-ping"></span>'
      + '</button>'
      + '<div class="ovw-tip ovw-hidden" role="button" tabindex="0">'
      +   '<button class="ovw-tip-x" aria-label="'+t('closeAria')+'">&times;</button>'
      +   '<div class="ovw-tip-t">'+t('bubbleTitle')+'</div>'
      +   '<div class="ovw-tip-m">'+t('bubbleMsg')+'</div>'
      +   '<span class="ovw-tip-cta">'+t('bubbleCta')+' '+ic('crosshair')+'</span>'
      + '</div>'
      + '</div>';

    launcherEl = widget.querySelector('.ovw-bub');
    tipEl = widget.querySelector('.ovw-tip');

    launcherEl.addEventListener('click', openModal);
    tipEl.addEventListener('click', function(e){ if(!e.target.closest('.ovw-tip-x')) openModal(); });
    tipEl.addEventListener('keydown', function(e){ if(e.key==='Enter'||e.key===' ') openModal(); });
    widget.querySelector('.ovw-tip-x').addEventListener('click', function(e){ e.stopPropagation(); hideTip(); });

    // Globito aparece solo tras 4.5s (una vez por sesion)
    var seen = false;
    try { seen = sessionStorage.getItem('ovw_tip_seen')==='1'; } catch(e){}
    if(!seen){ tipTimer = setTimeout(showTip, 4500); }
  }

  function syncLauncherText(){
    if(!widget) return;
    var tt=widget.querySelector('.ovw-tip-t'), tm=widget.querySelector('.ovw-tip-m'), tc=widget.querySelector('.ovw-tip-cta');
    if(tt) tt.textContent=t('bubbleTitle');
    if(tm) tm.textContent=t('bubbleMsg');
    if(tc) tc.innerHTML=t('bubbleCta')+' '+ic('crosshair');
  }

  // El globito se muestra UNA vez por sesion (antes volvia en cada pagina hasta
  // cerrarlo a mano) y en el telefono se va solo a los 9s.
  function showTip(){
    if(!tipEl) return;
    tipEl.classList.remove('ovw-hidden');
    try { sessionStorage.setItem('ovw_tip_seen','1'); } catch(e){}
    if(window.matchMedia && window.matchMedia('(max-width:520px)').matches){
      tipTimer = setTimeout(function(){ if(tipEl) tipEl.classList.add('ovw-hidden'); }, 9000);
    }
  }
  function hideTip(){
    if(tipEl){ tipEl.classList.add('ovw-hidden'); }
    try { sessionStorage.setItem('ovw_tip_seen','1'); } catch(e){}
  }

  /* Bloqueo del scroll de la tienda con el quiz abierto. overflow:hidden en <html>
     NO frena el scroll tactil en iOS: la pagina de atras se movia y asomaba por
     abajo (caso real, iPhone de Over 2026-09). En tactil se fija el <body> en su
     posicion y al cerrar se devuelve el cliente exactamente adonde estaba. */
  function lockScroll(){
    var de = document.documentElement, b = document.body.style;
    lockY = window.pageYOffset || de.scrollTop || 0;
    de.classList.add('ovw-lock');
    de.style.overflow = 'hidden';
    lockFixed = !!(window.matchMedia && window.matchMedia('(pointer:coarse)').matches);
    if(lockFixed){ b.position='fixed'; b.top=(-lockY)+'px'; b.left='0'; b.right='0'; b.width='100%'; }
  }
  function unlockScroll(){
    var de = document.documentElement, b = document.body.style;
    de.classList.remove('ovw-lock');
    de.style.overflow = '';
    if(lockFixed){
      b.position=''; b.top=''; b.left=''; b.right=''; b.width='';
      var prev = de.style.scrollBehavior; de.style.scrollBehavior = 'auto';
      window.scrollTo(0, lockY);
      de.style.scrollBehavior = prev;
    }
    lockFixed = false;
  }
  // Con el quiz abierto el resto de la pagina queda inerte (teclado / lector de pantalla).
  function setInert(on){
    if(on){
      inertEls = [];
      Array.prototype.forEach.call(document.body.children, function(el){
        if(el===widget || el.contains(widget) || /^(SCRIPT|STYLE|LINK|NOSCRIPT)$/.test(el.tagName)) return;
        if(!el.hasAttribute('inert')){ el.setAttribute('inert',''); inertEls.push(el); }
      });
    } else {
      inertEls.forEach(function(el){ el.removeAttribute('inert'); });
      inertEls = [];
    }
  }

  function openModal(){
    if(modalEl && modalEl.style.display==='flex') return; // ya abierto
    hideTip();
    syncLive();
    if(tipTimer) clearTimeout(tipTimer);
    if(!modalEl){
      modalEl = document.createElement('div');
      modalEl.className = 'ovw-modal';
      modalEl.setAttribute('role','dialog');
      modalEl.setAttribute('aria-modal','true');
      modalEl.setAttribute('aria-label', t('dialogLbl'));
      // La X vive en una capa sticky: no se va con el scroll.
      modalEl.innerHTML = '<div class="ovw-modal-inner"><div class="ovw-stick"><button class="ovw-close" aria-label="'+t('closeAria')+'">&times;</button></div><div class="ovw-mount"></div></div>';
      widget.appendChild(modalEl);
      // Cierra al tocar FUERA solo si el toque empezo fuera (no al soltar una seleccion/arrastre).
      modalEl.addEventListener('pointerdown', function(e){ downOnOverlay = (e.target===modalEl); });
      modalEl.addEventListener('click', function(e){ if(e.target===modalEl && downOnOverlay) closeModal(); downOnOverlay=false; });
      modalEl.querySelector('.ovw-close').addEventListener('click', function(){ closeModal(); });
    }
    lastFocus = document.activeElement;
    try{
      if(history.state && history.state.ovw){ histPushed = true; }
      else if(window.matchMedia && window.matchMedia('(max-width:520px),(max-height:520px)').matches){
        var st = {}; var cur = history.state;
        if(cur && typeof cur==='object'){ for(var k in cur){ st[k]=cur[k]; } }
        st.ovw = 1; if(st.searchParams===undefined) st.searchParams = (location.search||'').slice(1);
        history.pushState(st, '', location.href);
        histPushed = true;
      }
    }catch(e){}
    modalEl.style.display = 'flex';
    widget.classList.add('ovw-open');
    lockScroll();
    setInert(true);
    if(!built){ buildShell(modalEl.querySelector('.ovw-mount')); built = true; }
    render();
    escBound = onKeydown; document.addEventListener('keydown', escBound);
    // 'Atras' del navegador / swipe de iPhone cierra el quiz en vez de sacar al cliente
    // de la pagina (entrada de historial creada arriba). Lleva searchParams para que el
    // popstate de Dawn (filtros de coleccion) la ignore.
    // foco al boton de cerrar (accesibilidad)
    var c = modalEl.querySelector('.ovw-close'); if(c){ try{ c.focus({preventScroll:true}); }catch(e){ c.focus(); } }
  }

  function onKeydown(e){
    if(e.key==='Escape'){ closeModal(); return; }
    if(e.key==='Tab' && modalEl){ trapFocus(e); }
  }
  function trapFocus(e){
    var f = modalEl.querySelectorAll('button,[href],input,select,textarea,[tabindex]:not([tabindex="-1"])');
    f = Array.prototype.filter.call(f, function(el){ return !el.disabled && el.offsetParent!==null; });
    if(!f.length) return;
    var first=f[0], last=f[f.length-1];
    if(e.shiftKey && document.activeElement===first){ e.preventDefault(); last.focus(); }
    else if(!e.shiftKey && document.activeElement===last){ e.preventDefault(); first.focus(); }
  }
  function closeModal(fromPop){
    if(!modalEl || modalEl.style.display!=='flex') return;
    modalEl.style.display = 'none';
    widget.classList.remove('ovw-open');
    setInert(false);
    unlockScroll();
    if(escBound){ document.removeEventListener('keydown', escBound); escBound=null; }
    if(histPushed){
      histPushed = false;
      if(!fromPop){ try{ if(history.state && history.state.ovw) history.back(); }catch(e){} }
    }
    if(lastFocus && lastFocus.focus && document.contains(lastFocus)){ try{ lastFocus.focus({preventScroll:true}); }catch(e){} }
    lastFocus = null;
  }
  window.addEventListener('popstate', function(){
    if(modalEl && modalEl.style.display==='flex'){ histPushed = false; closeModal(true); }
  });
  // Safari restaura la pagina desde su cache al volver con 'atras' desde /cart:
  // el boton quedaba 'Anadiendo…' y deshabilitado.
  window.addEventListener('pageshow', function(e){
    if(e.persisted && S.adding){ cartReq++; S.adding=false; S.cartSlow=false; if(root && S.step>6 && S.phase==='result') render(); }
  });

  /* ---------- LINK DIRECTO: abre el builder solo ----------
     Comparte cualquiera de estos y el quiz se abre al entrar:
       https://TUTIENDA.com/#bundle
       https://TUTIENDA.com/?bundle=1
       https://TUTIENDA.com/pages/arma-tu-bundle#bundle
     Tambien puedes poner en cualquier boton/enlace de la tienda: href="#bundle" */
  function shouldAutoOpen(){
    try{
      var h = (location.hash||'').toLowerCase();
      var q = (location.search||'').toLowerCase();
      return h.indexOf('bundle')>=0 || h.indexOf('armar')>=0 || /[?&](bundle|builder|armar)(=|&|$)/.test(q);
    }catch(e){ return false; }
  }
  function maybeAutoOpen(){ if(inlineHost) return; if(shouldAutoOpen()) openModal(); }

  /* ---------- INIT ---------- */
  function boot(){
    // Idioma inicial segun el navegador del cliente (ES por defecto solo si navega en espanol)
    try{ if(((navigator.language||'')+'').toLowerCase().indexOf('es')!==0) S.lang='en'; }catch(e){}
    try{ var ql=(new URLSearchParams(location.search).get('lang')||'').toLowerCase(); if(ql==='es'||ql==='en') S.lang=ql; }catch(e){}

    /* MODO INLINE: si la pagina tiene <div id="overdma-quiz-inline"></div>, el quiz
       se monta anclado como contenido de la pagina (sin burbuja ni modal ahi).
       En el resto de la tienda: burbuja flotante + modal, como siempre. */
    inlineHost = document.getElementById('overdma-quiz-inline');

    /* PAGINA DEL QUIZ. Lo normal: su plantilla propia (page.build-your-setup)
       trae el div. Respaldo: si la pagina cae a la plantilla generica (la de las
       resenas — caso real 2026-08: "abro el quiz y me sale la pantalla de
       resenas"), el widget crea su contenedor al inicio del main.
       La ruta tolera prefijo de idioma/mercado (/en-us/pages/...) y la barra final. */
    var onQuizPage = /\/pages\/build-your-setup\/?$/.test(location.pathname||'');
    if(!inlineHost && onQuizPage){
      var mainC = document.getElementById('MainContent') || document.body;
      inlineHost = document.createElement('div');
      inlineHost.id = 'overdma-quiz-inline';
      mainC.insertBefore(inlineHost, mainC.firstChild);
    }
    if(onQuizPage){
      // SOLO el quiz en esta pagina: oculta cualquier otra seccion del main, pero
      // nunca la que CONTIENE el quiz (con la plantilla propia vive dentro de una
      // seccion; la regla vieja la habria ocultado). Sin :has() -> no oculta nada.
      var hideSt = document.createElement('style');
      hideSt.textContent = '#MainContent > *:not(#overdma-quiz-inline):not(:has(#overdma-quiz-inline)){display:none !important;}';
      document.head.appendChild(hideSt);
    }

    if(inlineHost){
      injectCSS();
      var m = document.createElement('div');
      inlineHost.appendChild(m);
      buildShell(m);
      built = true;
      render();
      syncLive();
      return;
    }

    buildLauncher();
    maybeAutoOpen();
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // Si el cliente hace clic en un enlace href="#bundle" ya estando en la pagina:
  window.addEventListener('hashchange', function(){ if(inlineHost) return; if(shouldAutoOpen()) openModal(); });
})();
